import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { LanguageContext } from "../../context/LanguageContext";
import React from "react";
import {
  Switch,
  PageHeader,
  Radio,
  Button,
  Select,
  Input,
  Row,
  Col,
  Drawer,
  Steps,
  Divider,
  Descriptions,
  Form,
  Spin,
  message,
  Modal,
  Space,
  Tabs,
} from "antd";
import {
  SearchOutlined,
  RedoOutlined,
  DownloadOutlined,
  ExclamationCircleTwoTone,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { professionalAction, userActions } from "../../_actions";
import { FindAccusedTable } from "../FindAccusedPage/FindAccusedTable";
import { roleAction } from "../../_actions/roleby.action";
import moment from "moment";
import _, { sortBy } from "lodash";
import { adminService } from "../../_services/admin.service";
import { TableCrimeList } from "./crimeList";
import FilterList from "./filterList";
import { OtherInformation } from "../ProfessionalForm/Forms/OtherInformation";
import { NoticeForm } from "../ProfessionalForm/Forms/NoticeFrom";
import { GhunhaInfomation } from "../ProfessionalForm/Forms/GhunhaInfomation";
import { GhunhaInfomationTable } from "../ProfessionalForm/FormsTable/GhunhaInfomationTable";
import { BasicInformation } from "../ProfessionalForm/Forms/BasicInformation";
import { FindFormTable } from "../ProfessionalForm/FormsTable/FindFormTable";
import { SearchByCrimeCount } from "../ProfessionalForm/FormsTable/SearchByCrimeCount";
import { ArrestForm } from "../ProfessionalForm/Forms/ArrestForm";
import { pushNotificationService } from "../../_services/pushNotification";
import { notificationAction } from "../../_actions/notifications.actions";
import TextArea from "antd/lib/input/TextArea";
import { PreventiveInfomationTable } from "../ProfessionalForm/FormsTable/PreventiveInfomationTable";
import { PreventiveForm } from "../ProfessionalForm/Forms/PreventiveForm";
import { ViewFormModel } from "../ProfessionalForm/ViewForm/ViewFormModel";
import * as XLSX from "xlsx-js-style";
import { PoliceSideActions } from "../../_actions/police.side.actions";
import { NCRForm } from "../ProfessionalForm/Forms/NCRFrom";
import { NCRServiceAction } from "../../_actions/ncr.service";
import { NCRInfomationTable } from "../ProfessionalForm/FormsTable/ncrFormTable";
import { storeProceduresAction } from "../../_actions/stored.procedures.service";
import { mapAdminCityAction } from "../../_actions/mapAdminCity.action";
import { wantedNotificationAction } from "../../_actions/wantedNotification.action";
import MobileAddress from "../ProfessionalForm/FormsTable/MultipleMobileTable";
import MultipleMobileAddress from "../ProfessionalForm/FormsTable/MultipleMobileTable";
import MultipleMobile from "../ProfessionalForm/Forms/MultipleMobile";
import { CrimeDocumentVerification } from "../crime_document_verification/document_verification";
import filterList from "./filterList";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
const { TabPane } = Tabs;
const { Option } = Select;
const { Step } = Steps;

class AaropiShodha extends React.Component {
  static contextType = LanguageContext;
  state = {
    selectedOption: "data_entered_by_police_station",
    wanted_details: [],
    wanted_data: [],
    searchType: "name",
    searchInput: "",
    activeFilter: "specific", // "specific" or "advanced"
    advancedFilterTitle: null,
    advancedFilterKeyword: "",
    advancedFilterYear: "",
    advancedFilterPhoto: "all",
    showFilterOptions: false,
    totalAccusedCount: 0,
    totalPhotoCount: 0,
    tableLoading: false,
    criminalList: [],
    selectedHeadings: [],
    crimeTitle: [],
    currentPage: 0,
    pageSize: 10,
    totalPages: 0,
    filterLoading: false,
    filterData: [],
    year: [],
    main_head: [],
    selectCIty: [],
    is_filter: false,
    kayda: "",
    rulesName: "",
    kalam: [],
    current: 0,
    ghunhaInfomationData: [],
    basicInformationData: [],
    wantedHistory: [],
    otherInformationData: [],
    preventiveInformationData: [],
    ncrInformationData: [],
    editPreventiveInformationData: [],
    editPreventiveInformationIndex: null,
    editGunhaInformationData: [],
    editGunhaInformationIndex: null,
    editMobileIndex: null,
    arrestInformationData: [],
    noticeInformationData: [],
    arrestInformationIndex: null,
    isBasicInforSuccess: false,
    districts: [],
    isAccusedFormEdit: [],
    isEditForms: false,
    resetBasicForm: false,
    setCriminalViewModel: false,
    resetBaseFormRandom: 0,
    criminalActiveModel: false,
    criminalActiveReasoneValue: "",
    criminalActiveData: {},
    tableLoading: false,
    newflag: 0,
    findTextValue: "",
    findNumberValue: "",
    classActive1: false,
    classActive1: false,
    searchText: "",
    searchedColumn: "",
    modalVisible: false,
    startDate: null,
    endDate: null,
    modalData: null,
    isSearchPerformed: false,
    name: undefined,
    address: undefined,
    mobileNumber: undefined,
    selectedGender: undefined,
    pageSize: 10,
    total: 0,
    sortOrder: "desc",
    sortBy: "srNo", // Default sort by Sr. No.
    is_search: false,
    download: "arophi_excel",
    excelData: [],
    excel_loader: false,
    selectedPoliceStation: "",
    ncrShow: false,
    ncrDrawer: false,
    mapped_cities: [],
    selected_city: "",
    selectedNameType: "",
    cityName: "",
    arrestCreateLoad: false,
    arrestUpdateLoading: false,
    is_multiple_mobile: false,
    mobileData: [],
    mobile: [],
    mobileDrawer: false,
    document_verified: false,
    is_document_verified: false,
    districts: [],
    filter_backup: [],
  };
  basicInformationRef = React.createRef();
  ghunhaInfomationRef = React.createRef();
  otherInfomationRef = React.createRef();
  preventiveInfoRef = React.createRef();
  arrestInfomationRef = React.createRef();
  noticeInformationRef = React.createRef();
  ncrInformation = React.createRef();
  formRef = React.createRef();
  mobileRef = React.createRef();
  addressRef = React.createRef();

  openDocumentVerified = (id) => {
    this.setState({
      masterDataId: id,
      document_verified: true,
    });
  };

  closeDocumentVerified = () => {
    this.setState({
      masterDataId: null,
      document_verified: false,
    });
  };
  getMobileData = (id) => {
    adminService.getMobileData(id).then((res) => {
      this.setState({ mobile: res });
    });
  };
  handleMultipleMobile = (data) => {
    console.log("data", data);

    this.setState(
      {
        is_multiple_mobile: true,
        masterDataId: data,
      },
      () => {
        this.getMobileData(data);
      },
    );
  };
  onCloseMultipleMobileNumber = () => {
    this.setState({
      is_multiple_mobile: false,
    });
  };
  userMapCityDetails = () => {
    let temp = { id: this.props.user.id };

    mapAdminCityAction.userMapCityDetails(temp).then((res) => {
      const firstCityId = res.results[0]?.id;

      this.setState(
        {
          mapped_cities: res.results,
          selected_city: firstCityId,
        },
        () => {
          // ✅ CALLBACK ensures state is updated
          this.formRef.current?.setFieldsValue({
            selected_city: firstCityId,
          });

          // 🔥 NOW selected_city exists
          this.getData();
          this.imageCount();
        },
      );
    });
  };

  handleKala = (e) => {
    this.setState({
      kayda: e,
    });
    this.props.dispatch(professionalAction.getKalam(e));
  };

  getMainHead = () => {
    professionalAction.getMainHead().then((res) => {
      console.log("res", res.data);
      this.setState({
        main_head: res.data,
      });
    });
  };

  handleYear = (e) => {
    this.setState({ year: e });
  };

  handleDistricts = (e) => {
    console.log("Selected districts:", e);

    const { filter_backup } = this.state;

    // If cleared
    if (!e || e.length === 0) {
      this.setState({
        districts: [],
        filterData: filter_backup,
        totalAccusedCount: filter_backup.length,
        totalPhotoCount: filter_backup.reduce(
          (sum, res) => sum + (res.photo ? 1 : 0),
          0,
        ),
      });
      return;
    }

    // Convert to lowercase for comparison
    const selectedDistricts = e.map((d) => d.toLowerCase());

    const filterData = filter_backup.filter((item) => {
      const itemDistrict = (item.districtName || item.DistrictName || "")
        .toLowerCase()
        .trim();

      return selectedDistricts.includes(itemDistrict);
    });

    let totalPhotoCount = filterData.reduce(
      (sum, res) => sum + (res.photo ? 1 : 0),
      0,
    );

    this.setState({
      districts: e,
      filterData,
      totalAccusedCount: filterData.length,
      totalPhotoCount,
    });
  };
  handleOptionChange = (e) => {
    console.log("e", e.target.value);
    this.setState(
      {
        selectedOption: e.target.value,
        activeFilter: "specific",
        searchType: "name",
        searchInput: "",
        year: [],
        searchText: "",
      },
      () => {
        this.getData();
        this.imageCount();
      },
    );
  };
  handleSearchTypeChange = (value) => {
    this.setState({ searchType: value });
  };
  handleSearchInputChange = (e) => {
    this.setState({ searchInput: e.target.value });
  };

  handleNameType = (value) => {
    this.setState({
      selectedNameType: value,
      sortOrder: "desc",
      sortBy: "srNo",
    });
  };

  callStoreProcedure = async (obj) => {
    const { advancedFilterTitle, year, selectedOption } = this.state;
    const hasYear = year.length > 0;

    /* --------- शीर्षक --------- */
    if (advancedFilterTitle === "शीर्षक") {
      if (selectedOption === "info_within_police_station_limits") {
        return await storeProceduresAction.get_crime_data_shirshak(obj);
      }
      if (selectedOption === "data_entered_by_police_station") {
        return await storeProceduresAction.get_crime_data_shirshak_haddit_gunhe(
          obj,
        );
      }
      if (selectedOption === "data_entered_by_id") {
        return await storeProceduresAction.get_crime_data_shirshak_usr(obj);
      }
    }

    /* --------- लघु शीर्षक --------- */
    if (advancedFilterTitle === "लघु शीर्षक") {
      if (selectedOption === "info_within_police_station_limits") {
        return await storeProceduresAction.get_crime_data_laghu_shirshak(obj);
      }
      if (selectedOption === "data_entered_by_police_station") {
        return await storeProceduresAction.get_crime_data_laghu_shirshak_haddit_gunhe(
          obj,
        );
      }
      if (selectedOption === "data_entered_by_id") {
        return await storeProceduresAction.get_crime_data_laghu_shirshak_usr(
          obj,
        );
      }
    }

    /* --------- मोडस --------- */
    if (advancedFilterTitle === "मोडस") {
      if (selectedOption === "info_within_police_station_limits") {
        return await storeProceduresAction.get_crime_data_modas(obj);
      }
      if (selectedOption === "data_entered_by_police_station") {
        return await storeProceduresAction.get_crime_data_modas_haddit_gunhe(
          obj,
        );
      }
      if (selectedOption === "data_entered_by_id") {
        return await storeProceduresAction.get_crime_data_modas_usr(obj);
      }
    }

    /* --------- कायदा --------- */
    if (advancedFilterTitle === "कायदा") {
      if (selectedOption === "info_within_police_station_limits") {
        return await storeProceduresAction.get_crime_data_kayda(obj);
      }
      if (selectedOption === "data_entered_by_police_station") {
        return await storeProceduresAction.get_crime_data_kayda_haddit_gunhe(
          obj,
        );
      }
      if (selectedOption === "data_entered_by_id") {
        return await storeProceduresAction.get_crime_data_kayda_usr(obj);
      }
    }

    /* --------- ONLY YEAR FILTER (no advancedFilterTitle) --------- */
    if (!advancedFilterTitle && hasYear) {
      if (selectedOption === "info_within_police_station_limits") {
        return await storeProceduresAction.get_crime_data_modas(obj);
      }
      if (selectedOption === "data_entered_by_police_station") {
        return await storeProceduresAction.get_crime_data_modas_haddit_gunhe(
          obj,
        );
      }
      if (selectedOption === "data_entered_by_id") {
        return await storeProceduresAction.get_crime_data_modas_usr(obj);
      }
    }
  };

  handleSearchFilter = async () => {
    this.setState({
      filterLoading: true,
      is_filter: true,
    });
    const {
      advancedFilterTitle,
      selectedHeadings,
      year,
      crimeTitle,
      selectCIty,
      advancedFilterPhoto,
      sortBy,
      sortOrder,
    } = this.state;
    const { user } = this.props;
    console.log("user", user);

    // let obj = {};
    // if (user?.role) {
    //   // Common fields
    //   obj = {
    //     heading:
    //       advancedFilterTitle === "शीर्षक" &&
    //       selectedHeadings.length > 0 &&
    //       selectedHeadings,
    //     year: year.length > 0 && year,
    //     basicHadering:
    //       advancedFilterTitle === "लघु शीर्षक" &&
    //       crimeTitle.length > 0 &&
    //       crimeTitle,
    //     crime_title:
    //       advancedFilterTitle === "मोडस" && crimeTitle.length > 0 && crimeTitle,
    //     cities: selectCIty.length > 0 && selectCIty,
    //     rulesName: advancedFilterTitle === "कायदा" && this.state.kayda,
    //     kalam: advancedFilterTitle === "कायदा" && this.state.kalam,
    //     photo: advancedFilterPhoto && advancedFilterPhoto,
    //     sortField: sortBy && sortBy,
    //     sortOrder: sortOrder && sortOrder,
    //     sortField: sortBy || null,
    //     sortOrder: sortOrder || null,
    //   };

    //   // Role-based label and ID
    //   if (user.role === "4") {
    //     obj.label = "admin";
    //     obj.cityId = user.cityId;
    //   } else if (user.role === "2") {
    //     obj.label = "police_side";
    //     obj.district = user.districtId;
    //   } else if (user.role === "9" || user.role === "10") {
    //     obj.label = "officer_side";
    //     obj.districtId = user.map_districtId;
    //   }
    // }
    let obj1 = {
      year:
        year && year.length > 0
          ? [].concat(year).join(",") // array → "2023,2024"
          : null,
    };
    if (["4", "12"].includes(user.role)) {
      obj1.label = "admin";
      obj1.id = user.role === "12" ? this.state.selected_city : user.cityId;
    } else if (user.role === "2") {
      obj1.label = "police";
      obj1.id = user.districtId;
    } else if (user.role === "9" || user.role === "10") {
      obj1.label = "police";
      obj1.id =
        user.map_districtId.length > 0
          ? [].concat(user.map_districtId).join(",") // array → "2023,2024"
          : null;
    }
    if (advancedFilterTitle === "शीर्षक") {
      obj1.heading =
        selectedHeadings && selectedHeadings.length > 0
          ? [].concat(selectedHeadings).join(",") // Correct for heading
          : null;
    }
    if (advancedFilterTitle === "लघु शीर्षक") {
      obj1.heading =
        crimeTitle && crimeTitle.length > 0
          ? [].concat(crimeTitle).join(",")
          : null;
    }
    if (advancedFilterTitle === "मोडस") {
      obj1.heading =
        crimeTitle && crimeTitle.length > 0
          ? [].concat(crimeTitle).join(",")
          : null;
    }
    if (advancedFilterTitle === "कायदा") {
      obj1.rule = this.state.kayda;

      if (this.state.kalam.length > 0) {
        const input = [].concat(this.state.kalam).join(",");
        obj1.kalam = input
          .split(",")
          .map((item) => {
            if (item.includes(".")) {
              let [num, rest] = item.split(".");
              return `${num},'${rest}'`;
            } else {
              return `'${item}'`;
            }
          })
          .join(",");
      } else {
        obj1.kalam = null;
      }
    }

    if (advancedFilterTitle != "") {
      if (this.state.selectedOption === "info_within_police_station_limits") {
        try {
          // const response =
          //   this.props.user.role === "4"
          //     ? await this.callStoreProcedure(obj1)
          //     : await adminService.getResidentsByPoliceStationByFilter(obj);
          const response = await this.callStoreProcedure(obj1);
          console.log("response", response);
          const data = await response.json();
          let list = data.results;
          console.log("Response Data:", data.results);
          let totalPhotoCount = list.reduce(
            (sum, res) => sum + (res.photo && res.photo != null ? 1 : 0),
            0,
          );
          this.setState({
            filterData: list,
            filterLoading: false,
            totalAccusedCount: list.length,
            totalPhotoCount: totalPhotoCount,
            excelData: list,
            filter_backup: list,
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }

      if (this.state.selectedOption === "data_entered_by_police_station") {
        try {
          // const response =
          //   this.props.user.role === "4"
          //     ? await this.callStoreProcedure(obj1)
          //     : await adminService.getCriminalsByPoliceStationAreaByFiter(obj);
          const response = await this.callStoreProcedure(obj1);
          console.log("response", response);
          const data = await response.json();
          let list = data.results;
          console.log("Response Data:", data);
          let totalPhotoCount = list.reduce(
            (sum, res) =>
              sum +
              (res.photo && res.photo.length > 0 && res.photo[0] !== ""
                ? 1
                : 0),
            0,
          );
          this.setState({
            filterData: list,
            filterLoading: false,
            totalAccusedCount: list.length,
            totalPhotoCount: totalPhotoCount,
            excelData: list,
            filter_backup: list,
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      if (this.state.selectedOption == "data_entered_by_id") {
        let obj = {
          id: user.id,
          year:
            year && year.length > 0
              ? [].concat(year).join(",") // array → "2023,2024"
              : null,
        };

        if (advancedFilterTitle === "शीर्षक") {
          obj.heading =
            selectedHeadings && selectedHeadings.length > 0
              ? [].concat(selectedHeadings).join(",") // Correct for heading
              : null;
        }
        if (advancedFilterTitle === "लघु शीर्षक") {
          obj.heading =
            crimeTitle && crimeTitle.length > 0
              ? [].concat(crimeTitle).join(",")
              : null;
        }
        if (advancedFilterTitle === "मोडस") {
          obj.heading =
            crimeTitle && crimeTitle.length > 0
              ? [].concat(crimeTitle).join(",")
              : null;
        }
        if (advancedFilterTitle === "कायदा") {
          obj.rule = this.state.kayda;

          if (this.state.kalam.length > 0) {
            const input = [].concat(this.state.kalam).join(",");
            obj.kalam = input
              .split(",")
              .map((item) => {
                if (item.includes(".")) {
                  let [num, rest] = item.split(".");
                  return `${num},'${rest}'`;
                } else {
                  return `'${item}'`;
                }
              })
              .join(",");
          } else {
            obj.kalam = null;
          }
        }
        try {
          const response = await this.callStoreProcedure(obj);
          console.log("response", response);
          const data = await response.json();
          let list = data.results;
          console.log("Response Data:", data);
          let totalPhotoCount = list.reduce(
            (sum, res) =>
              sum +
              (res.photo && res.photo.length > 0 && res.photo[0] !== ""
                ? 1
                : 0),
            0,
          );
          this.setState({
            filterData: list,
            filterLoading: false,
            totalAccusedCount: list.length,
            totalPhotoCount: totalPhotoCount,
            excelData: list,
            filter_backup: list,
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }
  };
  sortbyFilter = () => {
    const { sortBy, sortOrder } = this.state;
    console.log("sort by", sortBy, sortOrder);

    const { filterData } = this.state;

    const sortedData = [...filterData].sort((a, b) => {
      let x = a[sortBy] ?? "";
      let y = b[sortBy] ?? "";

      // If both values are numeric strings → sort as numbers
      const isNumeric = !isNaN(x) && !isNaN(y);

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return sortOrder === "asc" ? x - y : y - x;
      }

      // Otherwise sort as strings
      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();

      return sortOrder === "desc" ? x.localeCompare(y) : y.localeCompare(x);
    });

    this.setState({ filterData: sortedData });
  };
  handleSearch = () => {
    const { searchType, searchInput, sortBy, sortOrder, year } = this.state;
    const { user } = this.props;
    this.setState({
      filterLoading: true,
      totalPhotoCount: 0,
      totalAccusedCount: 0,
      is_search: true,
    });
    console.log(
      "Searching with:",
      this.state.searchType,
      this.state.searchInput,
    );
    let obj = {};

    if (user?.role) {
      // Common fields
      obj = {
        sortField: sortBy || null,
        sortOrder: sortOrder || null,
      };

      // Role-based label and ID
      if (["4", "12"].includes(user.role)) {
        obj.label = "admin";
        obj.cityId =
          user.role === "12" ? this.state.selected_city : user.cityId;
      } else if (user.role === "2") {
        obj.label = "police_side";
        obj.district = user.districtId;
      } else if (user.role === "9" || user.role === "10") {
        obj.label = "officer_side";
        obj.districtId = user.map_districtId;
      }

      // Search type specific condition
      switch (this.state.searchType) {
        case "name":
          obj.searchText = searchInput;
          break;
        case "crime":
          obj.gunaNUmber = searchInput;
          break;
        case "masterId":
          obj.searchId = searchInput;
          break;
        default:
          break;
      }
    }
    obj.year = searchType === "crime" && year.length > 0 && year;
    if (searchType === "mobile_no") {
      obj.mobile_no = searchInput;
    }
    if (searchType === "adhaar_number") {
      obj.adhaar_number = searchInput;
    }

    if (this.state.selectedOption === "info_within_police_station_limits") {
      adminService.getResidentsByPoliceStationSearch(obj).then((res) => {
        res &&
          res.text().then((criminalList) => {
            let criminal = JSON.parse(criminalList);
            let list = criminal.results;
            let totalPhotoCount = list.reduce(
              (sum, res) =>
                sum +
                (res.photo && res.photo.length > 0 && res.photo[0] !== ""
                  ? 1
                  : 0),
              0,
            );
            this.setState({
              filterData: list,
              filterLoading: false,
              totalAccusedCount: list.length,
              totalPhotoCount: totalPhotoCount,
            });
          });
      });
    }
    if (this.state.selectedOption === "data_entered_by_police_station") {
      adminService.getCriminalsByPoliceStationAreaSearch(obj).then((res) => {
        res &&
          res.text().then((criminalList) => {
            let criminal = JSON.parse(criminalList);
            let list = criminal.results;
            let totalPhotoCount = list.reduce(
              (sum, res) =>
                sum +
                (res.photo && res.photo.length > 0 && res.photo[0] !== ""
                  ? 1
                  : 0),
              0,
            );
            this.setState({
              filterData: list,
              filterLoading: false,
              totalAccusedCount: list.length,
              totalPhotoCount: totalPhotoCount,
            });
          });
      });
    }
    if (this.state.selectedOption == "data_entered_by_id") {
      let obj1 = {};
      if (user?.role) {
        // Common fields
        obj1 = {
          sortField: sortBy || null,
          sortOrder: sortOrder || null,
          id: user.id,
          year: searchType === "crime" && year.length > 0 && year,
        };

        // Search type specific condition
        switch (this.state.searchType) {
          case "name":
            obj1.searchText = searchInput;
            break;
          case "crime":
            obj1.gunaNUmber = searchInput;
            break;
          case "masterId":
            obj1.searchId = searchInput;
            break;
          default:
            break;
        }
      }
      if (searchType === "mobile_no") {
        obj1.mobile_no = searchInput;
      }
      if (searchType === "adhaar_number") {
        obj1.adhaar_number = searchInput;
      }

      adminService.getResidentsByPoliceIdStationSearch(obj1).then((res) => {
        res &&
          res.text().then((criminalList) => {
            let criminal = JSON.parse(criminalList);
            let list = criminal.results;
            let totalPhotoCount = list.reduce(
              (sum, res) =>
                sum +
                (res.photo && res.photo.length > 0 && res.photo[0] !== ""
                  ? 1
                  : 0),
              0,
            );
            this.setState({
              filterData: list,
              filterLoading: false,
              totalAccusedCount: list.length,
              totalPhotoCount: totalPhotoCount,
            });
          });
      });
    }

    // Implement search logic here
  };

  getOverallCityWiseName = () => {
    const { searchType, searchInput, sortBy, sortOrder, year } = this.state;
    this.setState({
      filterLoading: true,
      totalPhotoCount: 0,
      totalAccusedCount: 0,
      is_search: true,
    });
    const { user } = this.props;
    let obj = {
      type: searchType,
      searchText: searchInput,
      sortField: sortBy || null,
      sortOrder: sortOrder || null,
    };
    adminService.getOverallCityWiseName(obj).then((res) => {
      let list = res.results;
      let totalPhotoCount = list.reduce(
        (sum, res) =>
          sum +
          (res.photo && res.photo.length > 0 && res.photo[0] !== "" ? 1 : 0),
        0,
      );
      this.setState({
        filterData: list,
        filterLoading: false,
        totalAccusedCount: list.length,
        totalPhotoCount: totalPhotoCount,
      });
    });
  };

  handleNameTypeSearch = () => {
    const { selectedNameType } = this.state;
    if (selectedNameType === "self") {
      this.handleSearch();
    }
    if (selectedNameType === "all") {
      console.log("test");
      this.getOverallCityWiseName();
    }
  };

  handleReset = () => {
    this.setState({
      // searchType: null,
      searchText: "",
      searchInput: "",
      selectedHeadings: [],
      filterData: [],
      year: [],
      crimeTitle: [],
      is_filter: false,
      kayda: "",
      kalam: [],
      advancedFilterPhoto: "all",
      selectCIty: [],
      is_search: false,
      selectedNameType: "self",
      searchType: "name",
      // selectedPoliceStation: "",
    });
    this.getData();
    this.imageCount();
  };

  handleResetFilter = () => {
    this.setState(
      {
        sortBy: "",
      },
      () => {
        if (this.state.is_search === true) {
          this.handleSearch();
        }
        if (this.state.is_filter === true) {
          this.handleSearchFilter();
        }
        if (!this.state.is_search && !this.state.is_filter) {
          this.getData();
        }
      },
    );
  };
  handleFilterChange = (filterType) => {
    // Only switch the search form. Keep the current table (criminalList)
    // visible until the user actually searches. is_search / is_filter must
    // stay false here — setting them true shows empty FilterList instead.
    this.setState({
      activeFilter: filterType,
      is_search: false,
      is_filter: false,
      searchInput: "",
      searchText: "",
      searchType: "name",
      selectedNameType: "self",
      advancedFilterTitle: null,
      advancedFilterPhoto: "all",
      kayda: undefined,
      kalam: [],
      crimeTitle: [],
      selectedHeadings: [],
      year: [],
      selectCIty: [],
      filterData: [],
    });
  };
  handleAdvancedFilterTitleChange = (value) => {
    this.setState({
      advancedFilterTitle: value,
      crimeTitle: [],
      selectedHeadings: [],
    });
  };
  handleAdvancedFilterKeywordChange = (e) => {
    this.setState({ advancedFilterKeyword: e.target.value });
  };
  handleAdvancedFilterComponentChange = (value) => {
    this.setState({ selectCIty: value });
  };
  handleAdvancedFilterYearChange = (e) => {
    this.setState({ advancedFilterYear: e.target.value });
  };
  handleAdvancedFilterPhotoChange = (e) => {
    const value = e.target.value;
    const { filter_backup, filterData } = this.state; // always trust original backup

    let filtered = [];
    let total = 0;

    if (value === "yes") {
      filtered = filter_backup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      );
    } else if (value === "no") {
      filtered = filter_backup.filter(
        (item) =>
          item.photo === null || item.photo === "" || item.photo === undefined,
      );
    } else if (value === "all") {
      total = filter_backup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      ).length;
    }

    this.setState({
      advancedFilterPhoto: value,
      filterData: value === "all" ? filter_backup : filtered,
      totalAccusedCount:
        value === "all" ? filter_backup.length : filtered.length,
      totalPhotoCount:
        value === "yes" ? filtered.length : value === "all" ? total : 0,
    });
  };

  handleToggleFilterOptions = () => {
    this.setState((prevState) => ({
      showFilterOptions: !prevState.showFilterOptions,
    }));
  };
  handlePageChange = (page) => {
    this.setState(
      {
        currentPage: page - 1,
        criminalList1: [],
        criminalList: [],
        tableLoading: false,
      },
      () => {
        this.getData();
      },
    );
  };

  handlePageSizeChange = (current, size) => {
    this.setState(
      {
        pageSize: size,
        currentPage: current - 1,
      },
      () => {
        this.getData();
      },
    );
  };

  getData = () => {
    const { user } = this.props;
    const { currentPage, pageSize, sortBy, sortOrder, searchText } = this.state;
    console.log("selectedOption", this.state.selectedOption);
    console.log("call this.state.selected_city", this.state.selected_city);
    this.setState({
      tableLoading: true,
      criminalList: [],
    });
    let obj;
    if (["4", "12"].includes(user.role)) {
      obj = {
        id: user.role === "12" ? this.state.selected_city : user?.cityId,
        label: "admin",
        page: currentPage,
        size: pageSize,
        sortField: sortBy,
        sortOrder: sortOrder,
      };
    }
    if (user?.role === "2") {
      obj = {
        id: user?.districtId,
        label: "police_side",
        page: currentPage,
        size: pageSize,
        sortField: sortBy,
        sortOrder: sortOrder,
      };
    }
    if (user?.role === "9" || user?.role === "10") {
      obj = {
        districtId: user?.map_districtId,
        label: "officer_side",
        page: currentPage,
        size: pageSize,
        sortField: sortBy,
        sortOrder: sortOrder,
      };
    }
    if (this.state.selectedOption == "info_within_police_station_limits") {
      adminService.getResidentsByPoliceStation(obj).then((res) => {
        res &&
          res.text().then((criminalList) => {
            let criminal = JSON.parse(criminalList);
            let list = criminal.dataItem;
            this.setState({
              criminalList: list,
              tableLoading: false,
              totalAccusedCount: criminal.totalItems,
              totalPages: criminal.totalPages,
            });
          });
      });
    }
    if (this.state.selectedOption == "data_entered_by_police_station") {
      adminService.getCriminalsByPoliceStationArea(obj).then((res) => {
        res &&
          res.text().then((criminalList) => {
            let criminal = JSON.parse(criminalList);
            let list = criminal.dataItem;
            this.setState({
              criminalList: list,
              tableLoading: false,
              totalAccusedCount: criminal.totalItems,
              totalPages: criminal.totalPages,
            });
          });
      });
    }
    if (this.state.selectedOption == "data_entered_by_id") {
      let objTemp = {
        id: user?.id,
        page: currentPage,
        size: pageSize,
        sortField: sortBy,
        sortOrder: sortOrder,
      };
      adminService.getResidentsByPoliceStationById(objTemp).then((res) => {
        res &&
          res.text().then((criminalList) => {
            let criminal = JSON.parse(criminalList);
            let list = criminal.dataItem;
            this.setState({
              criminalList: list,
              tableLoading: false,
              totalAccusedCount: criminal.totalItems,
              totalPages: criminal.totalPages,
            });
          });
      });
    }
  };
  imageCount = () => {
    const { user } = this.props;
    let obj;
    if (["4", "12"].includes(user.role)) {
      obj = {
        id: user.role === "12" ? this.state.selected_city : user?.cityId,
        label: "admin",
      };
    }
    if (user?.role === "2") {
      obj = {
        id: user?.districtId,
        label: "police_side",
      };
    }
    if (user?.role === "9" || user?.role === "10") {
      obj = {
        districtId: user?.map_districtId,
        label: "officer_side",
      };
    }
    if (this.state.selectedOption == "info_within_police_station_limits") {
      adminService
        .getAccusedImageCount(obj)
        .then((res) => res.json())
        .then((criminalList) => {
          console.log("criminalList", criminalList);
          this.setState({
            totalPhotoCount: criminalList.totalAccusedImageCount, // ✅ update state
          });
        });
    }
    if (this.state.selectedOption == "data_entered_by_police_station") {
      adminService
        .getGunhaWithAccusedImage(obj)
        .then((res) => res.json())
        .then((criminalList) => {
          console.log("criminalList", criminalList);
          this.setState({
            totalPhotoCount: criminalList.totalMatchedRecords, // ✅ update state
          });
        });
    }
    if (this.state.selectedOption == "data_entered_by_id") {
      let obj1 = {
        id: user.id,
      };
      adminService
        .getAccusedByIdImageCount(obj1)
        .then((res) => res.json())
        .then((criminalList) => {
          console.log("criminalList", criminalList);
          this.setState({
            totalPhotoCount: criminalList.totalAccusedImageCount, // ✅ update state
          });
        });
    }
  };
  componentDidMount() {
    this.props.dispatch(professionalAction.getAllMaster());
    this.props.dispatch(professionalAction.getCity());

    this.props.dispatch(professionalAction.getDharm());
    this.props.dispatch(professionalAction.getKalam());
    this.props.dispatch(professionalAction.getKayda());
    this.props.dispatch(professionalAction.getCrimeType());
    this.props.dispatch(professionalAction.getCrimeTitle());
    this.props.dispatch(professionalAction.getStatus());
    this.getMainHead();

    this.getData();
    this.imageCount();
    if (this.props?.user?.role === "2") {
      this.getDistrictsid();
      this.getPoliceStationWithGhatak();
    }
    if (this.props.user.role === "12") {
      this.userMapCityDetails();
    }
    if (["4", "9", "10"].includes(this.props.user.role)) {
      this.props.dispatch(
        professionalAction.getDistrict(
          this.props.user && this.props.user.cityId,
          1,
        ),
      );
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.professionals?.pc_cities !==
        prevProps.professionals?.pc_cities &&
      this.props.user.role === "4"
    ) {
      const cityName = this.getCityName(this.props.user.cityId);

      this.setState({
        cityName,
        selectedNameType: "self",
      });
    }
  }

  // update profile

  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };

  showAccusedDrawer = () => {
    this.setState({
      accusedDrawer: true,
      resetBasicForm: true,
      isEditForms: false,
      resetBaseFormRandom: Math.random(),
      newflag: 0,
    });
  };

  onCloseAccusedDrawer = () => {
    this.setState((prevState) => ({
      basicInformationData: [],
      wantedHistory: [],
      otherInformationData: [],
      ghunhaInfomationData: [],
      editGunhaInformationData: [],
      ghunhaDrawer: false,
      accusedDrawer: false,
      current: 0,
      resetBasicForm: false,
      isEditForms: false,
      searchType: "accused",
      findCriminalList: [],
      findTextValue: "",
      checked: "",
      selectedPoliceStation: "",
      findNumberValue: "",
    }));
  };

  onClosePreventiveAccusedDrawer = () => {
    this.setState((prevState) => ({
      basicInformationData: [],
      wantedHistory: [],
      otherInformationData: [],
      ghunhaInfomationData: [],
      editGunhaInformationData: [],
      ghunhaDrawer: false,
      accusedPreventiveDrawer: false,
      current: 0,
      resetBasicForm: false,
      isEditForms: false,
    }));
  };

  onCloseNCRnumber = () => {
    this.setState({
      ncrShow: false,
    });
  };

  showghunhaDrawer = () => {
    this.setState({
      ghunhaDrawer: true,
      newGunha: Math.floor(Math.random() * Math.floor(5)),
      isGunhaEdit: false,
    });
  };

  onghunhaDrawerClose = () => {
    this.setState({
      ghunhaDrawer: false,
    });
  };

  showMobileDrawer = () => {
    this.setState({
      mobileDrawer: true,
      isMobileEdit: false,
      addresDrawer: false,
    });
  };

  showAddressDrawer = () => {
    this.setState({
      addresDrawer: true,
      mobileDrawer: false,
    });
  };

  closeAddressDrawer = () => {
    this.setState({
      addresDrawer: false,
    });
  };
  onMobileaDrawerClose = () => {
    this.setState({
      mobileDrawer: false,
    });
  };

  showarrestDrawer = () => {
    this.setState({
      arrestDrawer: true,
      newGunha: Math.floor(Math.random() * Math.floor(5)),
      isArrestEdit: false,
    });
  };

  showNoticeDrawer = () => {
    this.setState({
      noticeDrawer: true,
    });
  };
  onarrestDrawerClose = () => {
    this.setState({
      arrestDrawer: false,
    });
  };
  onNoticeDrawerClose = () => {
    this.setState({
      noticeDrawer: false,
    });
  };

  next = () => {
    if (this.state.current === 0) {
      this.basicInformationRef.current.onFinish();
    }
    if (this.state.current === 1) {
      if (this.state.ghunhaInfomationData.length) {
        this.setState({
          current: this.state.current + 1,
        });
      } else {
        this.errorMessage("किमान एक गुन्हा आवश्यक आहे");
      }
    }
  };

  prev = () => {
    if (this.state.current === 2) {
      this.otherInfomationRef.current.onFinish();
    }
    this.setState({
      current: this.state.current - 1,
    });
  };

  done = () => {
    // this.otherInfomationRef.current.onFinish();
  };

  onGunhaFormFiniesh = (data) => {
    let newEntery = {
      ...data,
      registernumberYear: data.registernumberYear
        ? moment(data.registernumberYear).format("YYYY")
        : moment(),
      districtName: this.getDistrictName(data.district),
      is_new_guna: "yes",
      userId: this.props.user.id,
    };
    this.setState((prevState) => ({
      ghunhaInfomationData: [...prevState.ghunhaInfomationData, newEntery],
      ghunhaDrawer: false,
    }));
  };

  OnMobileFormFinsiesh = (data, type) => {
    let newEntery = {
      mobileData: data,
    };
    setTimeout(() => {
      adminService
        .updateMobileAddress(newEntery)
        .then((res) => {
          message.success("Add successfully");

          this.getMobileData(this.state.masterDataId);

          // close drawer AFTER success
          this.closeAddressDrawer();
          this.onMobileaDrawerClose();
        })
        .catch((error) => {
          message.error("Something went wrong");
        });
    }, 1200);
  };

  onGunhaFormUpdate = (data) => {
    let newEntery = {
      ...data,
      registernumberYear: data.registernumberYear
        ? moment(data.registernumberYear).format("YYYY")
        : moment(),
      districtName: this.getDistrictName(data.district),
      userId: this.props.user && this.props.user.id,
    };
    let tempArray = this.state.ghunhaInfomationData;
    tempArray.splice(this.state.editGunhaInformationIndex, 1);
    this.setState((prevState) => ({
      ghunhaInfomationData: [],
      ghunhaInfomationData: [...tempArray, newEntery],
      ghunhaDrawer: false,
      editGunhaInformationIndex: null,
    }));
  };

  basicInformationFinish = (data) => {
    const normalizedWantedHistory = {
      ...data,
      ...this.buildWantedHistoryPayload(data),
    };
    this.setState((prevState) => ({
      basicInformationData: [data],
      wantedHistory: [normalizedWantedHistory],
    }));
    if (data) {
      this.setState({
        current: this.state.current + 1,
      });
    }
  };

  otherInformationFiniesh = (data) => {
    this.setState((prevState) => ({
      otherInformationData: [data],
    }));
  };

  uploadImage = (data) => {
    this.props.dispatch(professionalAction.uploadImage(data));
  };

  onGhunhaInfomationSave = () => {
    this.ghunhaInfomationRef.current.onFinish(true);
  };

  onGhunhaInfomationUpdate = () => {
    this.ghunhaInfomationRef.current.onFinish(false);
  };

  onGhunhaInfomationCancel = () => {
    this.setState((prevState) => ({
      ghunhaDrawer: false,
    }));
  };

  OnMobileInfromationSave = () => {
    if (this.state.mobileDrawer) {
      this.mobileRef.current.onFinish(true);
    }

    if (this.state.addresDrawer) {
      this.addressRef.current.onFinish(true);
    }
  };

  editMobilInformation = (data, index) => {
    this.setState({
      editMobile: [data],
      editMobileIndex: index,
      isMobileEdit: true,
    });
  };

  editGhunhaInfomation = (data, index) => {
    this.onCityChange(data.city, 2);
    this.setState((prevState) => ({
      editGunhaInformationData: [data],
      editGunhaInformationIndex: index,
      ghunhaDrawer: true,
      isGunhaEdit: true,
      newGunha: false,
      resetBasicForm: false,
    }));
  };

  deleteGhunhaInfomation = (data, index) => {
    let temp = this.state.ghunhaInfomationData;
    temp.splice(index, 1);
    this.setState((prevState) => ({
      ghunhaInfomationData: [...temp],
      editGunhaInformationIndex: index,
    }));
  };

  onArrestFormFiniesh = (data) => {
    setTimeout(() => {
      let values = {
        arrestInformationData: {
          ...data,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          district:
            this.props?.user.role === "2" ? this.props?.user.districtId : null,
        },
      };
      const masterId = this.state.isAccusedFormEdit[0].editId;
      this.props
        .dispatch(professionalAction.createArrestAction(values))
        .then((response) => {
          const arrestid =
            response && response.arrestInfo && response.arrestInfo[0]
              ? response.arrestInfo[0].id
              : null;
          if (response && masterId) {
            this.checkWantedGuna(masterId, null, "arrest", arrestid);
          }
        });
      message.info("Save Arrest Successfully !!");
      this.onarrestDrawerClose();
    }, 2000);
  };

  onArrestFormUpdate = (data, arrestInfo) => {
    const photoString = data?.photo.join(", ");
    data.photo = photoString;
    setTimeout(() => {
      let values = {
        arrestInformationData: {
          ...data,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          id: arrestInfo?.id,
          district:
            this.props?.user.role === "2" ? this.props?.user.districtId : null,
        },
      };

      const masterId = this.state.isAccusedFormEdit[0].editId;
      this.props
        .dispatch(professionalAction.updateArrestAction(values, arrestInfo?.id))
        .then((response) => {
          if (response && masterId) {
            this.checkWantedGuna(masterId, null, "arrest", arrestInfo?.id);
          }
        });
      message.info("Update Successfully !!");
      this.onarrestDrawerClose();
    }, 2000);
  };

  onNoticeFormFiniesh = (data) => {
    setTimeout(() => {
      let values = {
        NoticeInformationData: {
          ...data,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          districtId: this.props.user.role == "2" && this.props.user.districtId,
          districtName: this.props.user.role == "2" && this.state.districtName1,
        },
      };
      const masterId = this.state.isAccusedFormEdit[0].editId;
      this.props
        .dispatch(professionalAction.createNoticeInformation(values))
        .then((response) => {
          const noticeid =
            response && response.NoticeInfo && response.NoticeInfo[0]
              ? response.NoticeInfo[0].id
              : null;
          if (response && masterId) {
            this.checkWantedGuna(masterId, null, "notice", noticeid);
          }
        });
      message.info("Save Notice Successfully !!");
      this.onNoticeDrawerClose();
    }, 2000);
  };

  onNoticeFormUpdate = (data, arrestInfo) => {
    // const photoString = data?.photo.join(", ");
    // data.photo = photoString;
    setTimeout(() => {
      let values = {
        NoticeInformationData: {
          ...data,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          districtId: this.props.user.role == "2" && this.props.user.districtId,
          districtName: this.state.districtName1,
          id: arrestInfo?.id,
        },
      };

      const masterId = this.state.isAccusedFormEdit[0].editId;
      this.props
        .dispatch(
          professionalAction.updateNoticeInformation(values, arrestInfo?.id),
        )
        .then((response) => {
          if (response && masterId) {
            this.checkWantedGuna(masterId, null, "notice", arrestInfo?.id);
          }
        });
      message.info("Update Successfully !!");
      this.onNoticeDrawerClose();
    }, 2000);
  };

  onArrestInfomationSave = () => {
    if (this.state.arrestCreateLoad) return; // prevent double click

    this.setState({ arrestCreateLoad: true });
    this.arrestInfomationRef.current.onFinish(true);
  };

  onArrestInfomationUpdate = () => {
    if (this.state.arrestUpdateLoading) return; // prevent double click

    this.setState({ arrestUpdateLoading: true });
    this.arrestInfomationRef.current.onFinish(false);
  };

  onNoticeInfromationSave = () => {
    this.noticeInformationRef.current.onFinish(true);
  };
  onNoticeInfromationUpdate = () => {
    this.noticeInformationRef.current.onFinish(false);
  };

  onArrestInfomationCancel = () => {
    this.setState((prevState) => ({
      arrestDrawer: false,
    }));
  };
  editNoticeInformation = (data, index) => {
    this.setState((prevState) => ({
      noticeInformationData: [data],
      arrestInformationIndex: index,
      noticeDrawer: true,
      isNoticeEdit: true,
      newGunha: false,
      resetArrestForm: false,
    }));
  };

  editArrestInfomation = (data, index) => {
    this.setState((prevState) => ({
      arrestInformationData: [data],
      arrestInformationIndex: index,
      arrestDrawer: true,
      isArrestEdit: true,
      newGunha: false,
      resetArrestForm: false,
    }));
  };

  onCityChange = (cityId, form) => {
    if (cityId) {
      this.props.dispatch(professionalAction.getDistrict(cityId, form));
    }
  };

  onKaydaChange = (actId) => {
    if (actId) {
      this.props.dispatch(professionalAction.getKalam(actId));
    }
  };

  getDistrictName = (id) => {
    const { gunhaDistricts } = this.props.professionals;
    if (gunhaDistricts && gunhaDistricts.length) {
      return (
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(gunhaDistricts, function (o) {
          return o.id === id;
        })[0].DistrictName
      );
    }
  };

  buildWantedHistoryPayload = (wantedHistoryItem = {}, extraFields = {}) => {
    const wh = wantedHistoryItem || {};
    const user = this.props.user || {};
    const selectedType =
      wh.type === "history" || wh.type === "gunda"
        ? wh.type
        : [1, 2, 3].includes(Number(wh.historySheeter))
          ? "history"
          : [1, 2].includes(Number(wh.is_gunda))
            ? "gunda"
            : null;

    const basePayload = {
      userId: user.id || null,
      current_condition: wh.current_condition,
      current_condition_date:
        wh.current_condition_date && wh.current_condition_date,
      cityId: user.cityId,
      district: user.role === "2" && user.districtId,
      ...extraFields,
    };

    if (selectedType === "history") {
      const historySheeter = [1, 2, 3].includes(Number(wh.historySheeter))
        ? Number(wh.historySheeter)
        : null;
      return {
        ...basePayload,
        type: "history",
        historySheeter,
        history_date:
          historySheeter === 1 || historySheeter === 3 ? wh.history_date : null,
        is_gunda: null,
        gunda_date: null,
      };
    }

    if (selectedType === "gunda") {
      const isGunda = [1, 2].includes(Number(wh.is_gunda))
        ? Number(wh.is_gunda)
        : null;
      return {
        ...basePayload,
        type: "gunda",
        historySheeter: null,
        history_date: null,
        is_gunda: isGunda,
        gunda_date: isGunda === 1 ? wh.gunda_date : null,
      };
    }

    return {
      ...basePayload,
      type: null,
      historySheeter: null,
      history_date: null,
      is_gunda: null,
      gunda_date: null,
    };
  };

  onConfirm = () => {
    this.otherInfomationRef.current.onFinish();
    let name = this.state.basicInformationData[0].name;
    let policeName = this.state.basicInformationData[0].districtName;
    let wanted_history_data = this.buildWantedHistoryPayload(
      this.state.wantedHistory[0],
    );
    setTimeout(() => {
      let data = {
        basicInformation: { ...this.state.basicInformationData[0] },
        wantedHistory: { ...wanted_history_data },
        otherInformation: { ...this.state.otherInformationData[0] },
        gunhaInformation: [...this.state.ghunhaInfomationData],
        currentuser: { ...this.props.user },
      };
      let image = this.state.otherInformationData[0].accusedImage[0];

      this.props.dispatch(professionalAction.createCriminal(data));
      userActions
        .getAppUserTokens(
          this.props && this.props.user && this.props.user.cityId,
        )
        .then((apiRes) => {
          apiRes &&
            apiRes.text().then((res) => {
              res &&
                JSON.parse(res) &&
                JSON.parse(res).map((item) => {
                  let data = {
                    token: item.appToken,
                    title: "CMIS New Criminal Added",
                    body: name + " , " + policeName,
                    image:
                      image &&
                      "https://pcimageupload.s3.ap-south-1.amazonaws.com/" +
                        image,
                  };
                  pushNotificationService
                    .pushNotification(data)
                    .then((tokenRes) => {});
                });
            });
        });
      message.info("Save Successfully !!");
      this.onCloseAccusedDrawer();
    }, 1000);
  };

  getPreventiveActionsByDateAndId = (masterId) => {
    let obj = {
      masterId: masterId,
    };
    let temp;
    notificationAction.getPreventiveActionsByDateAndId(obj).then((res) => {
      res &&
        res.json().then((criminalList) => {
          console.log("preventive notification", criminalList?.data);
          let list = criminalList?.data;
          console.log("list", list);

          if (list) {
            let temp = {
              masterid: list.masterId,
              prevetive_id: list.preventiveid,
              gunaid: list.gunaid,
              userid: this.props.user.id,
            };

            if (this.props.user.role === "4") {
              temp.city = this.props.user.cityId;
            } else if (this.props.user.role === "2") {
              temp.district = this.props.user.districtId;
              temp.city = this.props.user.cityId;
            }
            this.preventiveActionNotification(temp);
          }

          this.setState({
            notificationData: list || [],
          });
        });
    });
  };

  preventiveActionNotification = (values) => {
    notificationAction.preventiveActionNotification(values).then((res) => {
      res &&
        res.json().then((criminalList) => {
          console.log("preventive notification", criminalList);
          if (criminalList.message === "Record created successfully") {
            Modal.info({
              icon: null, // remove default icon
              title: (
                <div style={{ textAlign: "center" }}>
                  <ExclamationCircleTwoTone
                    twoToneColor="#faad14"
                    style={{ fontSize: "40px", marginBottom: "10px" }}
                  />
                  <div
                    style={{
                      fontSize: "20px",
                      fontWeight: "bold",
                      marginTop: "10px",
                    }}
                  >
                    अलर्ट
                  </div>
                </div>
              ),
              width: 500,
              centered: true,
              content: (
                <div
                  style={{
                    lineHeight: "1.7",
                    fontSize: "16px",
                    wordBreak: "break-word",
                    textAlign: "center",
                    marginTop: "10px",
                  }}
                >
                  <p>
                    <strong>{this.state?.notificationData?.name}</strong>{" "}
                    आरोपीवर{" "}
                    <strong>
                      {this.state?.notificationData?.preventive_name}
                    </strong>{" "}
                    प्रतिबंधक कारवाई चालू असून, त्यावर{" "}
                    <strong>
                      {moment(this.state?.notificationData?.dateTime).format(
                        "DD.MM.YYYY",
                      )}
                    </strong>{" "}
                    रोजी{" "}
                    <strong>
                      {this.state?.notificationData?.districtName}
                    </strong>{" "}
                    पोलीस ठाणे मध्ये गुन्हा दाखल झालेला आहे.
                  </p>
                </div>
              ),
              onOk() {
                console.log("OK clicked");
              },
            });
          }
        });
    });
  };
  createWantedNotification = (values, info) => {
    const data = { data: values };
    if (values.length > 0) {
      wantedNotificationAction.createWantedNotification(data).then((res) => {
        console.log("res", res.inserted);
        console.log("this.state", this.state);
        if (res.inserted != 0) {
          const wantedDate = info && info.date
            ? moment(info.date).format("DD/MM/YYYY")
            : "";
          Modal.info({
            icon: null, // remove default icon
            title: (
              <div style={{ textAlign: "center" }}>
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "50%",
                    background: "#faad14",
                    color: "#fff",
                    fontSize: "36px",
                    fontWeight: "bold",
                    lineHeight: "56px",
                    margin: "0 auto",
                  }}
                >
                  !
                </div>
                <div
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    marginTop: "10px",
                  }}
                >
                  अलर्ट
                </div>
              </div>
            ),
            width: 500,
            centered: true,
            content: (
              <div
                style={{
                  lineHeight: "1.7",
                  fontSize: "16px",
                  wordBreak: "break-word",
                  textAlign: "center",
                  marginTop: "10px",
                }}
              >
                <p>
                  <strong>CMIS ID = </strong>
                  {info && info.cmisId}
                </p>
                <p>
                  <strong>नाव : </strong>
                  {info && info.name}
                </p>
                <p>
                  सदर चा आरोपी <strong>{info && info.districtName}</strong> पो.
                  स्टे यांना दि. <strong>{wantedDate}</strong> पासून पाहिजे आहे.
                </p>
                <p>कृपया त्यांना तात्काळ कळवा.</p>
              </div>
            ),
            onOk() {
              console.log("OK clicked");
            },
          });
        }
      });
    }
  };

  checkWantedGuna = (id, date, type, recordId) => {
    const temp = {
      masterId: id,
      date: date,
      type: type ? type : null,
    };
    if (type === "arrest" && recordId) {
      temp.arrestid = recordId;
    }
    if (type === "notice" && recordId) {
      temp.noticeid = recordId;
    }
    wantedNotificationAction.checkWantedGuna(temp).then((res) => {
      console.log("res", res);
      if (res.data) {
        let info = {
          cmisId: id,
          name: res?.data[0]?.name,
          date: res?.data[0]?.current_condition_date,
          districtName: res?.data[0]?.districtName,
        };
        this.setState({
          wanted_data: res?.data,
          wanted_details: info,
        });
        const temp = res.data.map((item) => ({
          gunaid: item.gunaid,
          masterid: id,
          arrestid:
            type === "arrest" ? recordId || item.arrestid : null,
          noticeid:
            type === "notice" ? recordId || item.noticeid : null,
          wantedId: item.wantedId,
          city: this.props.user.cityId,
          userid: this.props.user.id,
          district: this.props.user.role == "2" && this.props.user.districtId,
          type: type ? type : null,
        }));
        console.log("temp", temp);
        this.createWantedNotification(temp, info);
      }
    });
  };
  onUpdateConfirm = () => {
    this.otherInfomationRef.current.onFinish();
    const { gunhaInfor, otherInfo } = this.props.professionals;
    // this.setState({
    //   ghunhaInfomationData: [
    //     ...this.state.ghunhaInfomationData,
    //   ],
    // });
    console.log(
      "this.state.basicInformationData[0]",
      this.state.basicInformationData[0],
    );

    setTimeout(() => {
      let wanted_history_data = this.buildWantedHistoryPayload(
        this.state.wantedHistory[0],
        {
          masterId: this.state.isAccusedFormEdit[0].editId,
        },
      );

      let data = {
        basicInformation: { ...this.state.basicInformationData[0] },
        otherInformation: { ...this.state.otherInformationData[0] },
        wantedHistory: { ...wanted_history_data },
        gunhaInformation: [...this.state.ghunhaInfomationData],
        currentuser: { ...this.props.user },
        // this.state.basicInformationData
      };
      this.props.dispatch(
        professionalAction.updateCriminals(
          this.state.isAccusedFormEdit[0].editId,
          data,
        ),
      );

      setTimeout(() => {
        this.getPreventiveActionsByDateAndId(
          this.state.isAccusedFormEdit[0].editId,
        );
        console.log("this.props.user.cityId", this.props.user.cityId);
      }, 2000);

      this.getData();
      message.info("Update Successfully!!");
      this.onCloseAccusedDrawer();
    }, 1000);
  };

  getPreventiveList = () => {
    const { report_1_startDate, report_1_endDate, preventive_action } =
      this.props;
    const startDate = moment(report_1_startDate, "YYYY-MM-DD").format(
      "YYYY-MM-DD",
    );
    const endDate = moment(report_1_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
    const { user } = this.props;
    const data = {
      startDate: startDate,
      endDate: endDate,
      cityId: user.cityId,
      preventive_action: preventive_action,
    };
    professionalAction.getPreventiveList(data).then((res) => {
      res &&
        res.text().then((criminalList1) => {
          let criminal = JSON.parse(criminalList1);
          let list = criminal.results;
          let columns1 =
            list &&
            list &&
            list.map((itemObj, index) => {
              return {
                ...itemObj,
              };
            });

          let tempObj = columns1.map((res, index) => {
            return {
              ...res,
            };
          });
          this.setState({
            preventiveList: tempObj,
            criminalList: tempObj,
          });
        });
    });
  };

  onEditAccusedForm = (data) => {
    console.log("data ids", data);
    this.setState({
      userID: data.userId,
    });
    const ID = this.state.searchType === "crime" ? data?.masterId : data?.id;
    this.setState({
      masterId: ID,
    });
    let temo = this.props.dispatch(professionalAction.getCriminalsById(ID));

    temo.then((res) => {
      const {
        basicInfo,
        gunhaInfor,
        otherInfo,
        wantedHistory,
        document_verified,
      } = res;
      // let getEditGunhaTemp = _.filter(gunhaInfor, (o) => {
      //   return o.masterId === data.id;
      // });
      // let getEditOtherTemp = _.filter(otherInfo, (o) => {
      //   return o.masterId === data.id;
      // });
      let getEditGunhaTemp = _.filter(gunhaInfor, (o) => {
        return o.masterId === ID;
      });
      let getEditOtherTemp = _.filter(otherInfo, (o) => {
        return o.masterId === ID;
      });
      this.setState({
        basicInformationData: basicInfo,
        isAccusedFormEdit: [
          {
            // editId: data.id,
            editId: ID,
            guhnhaEditId: getEditGunhaTemp[0] && getEditGunhaTemp[0].id,
            otherEditId: getEditOtherTemp[0] && getEditOtherTemp[0].id,
            isEdit: true,
          },
        ],
        ghunhaInfomationData: [...getEditGunhaTemp],
        otherInformationData: [...getEditOtherTemp],
        isEditForms: true,
        accusedDrawer: true,
        newGunha: false,
        resetBasicForm: false,
        newflag: 1,
        wantedHistory: wantedHistory,
        is_document_verified: document_verified,
      });
    });
  };

  /**
   * Preventive Form
   *
   */
  editPreventiveInfomation = (data, index) => {
    this.setState((prevState) => ({
      editPreventiveInformationData: [data],
      editPreventiveInformationIndex: index,
      preventiveDrawer: true,
      isPreventiveEdit: true,
      newPreventive: false,
      resetBasicForm: false,
      resetPreventiveForm: false,
    }));
  };

  showpreventiveDrawer = () => {
    this.setState({
      preventiveDrawer: true,
      isPreventiveEdit: false,
      resetPreventiveForm: true,
    });
  };
  showNcrDrawer = () => {
    this.setState({
      ncrDrawer: true,
    });
  };

  onpreventiveDrawerClose = () => {
    this.setState({
      preventiveDrawer: false,
    });
  };
  onNcrDrawerClose = () => {
    this.setState({
      ncrDrawer: false,
    });
  };

  preventiveInformationFinish = (data) => {
    console.log("data preventive data save", data);
    this.setState((prevState) => ({
      preventiveInformationData: [data],
      newpreventiveInformationData: [data],
    }));
  };

  ncrInformationFinish = (data) => {
    console.log("data ncr data save", data);

    this.setState({
      ncrInformationData: data, // FIXED: store as object
    });
  };

  preventiveInformationUpdate = (data) => {
    this.setState((prevState) => ({
      preventiveInformationData: [data],
      newpreventiveInformationData: [data],
    }));
    console.log("data preventive data update", data);
  };

  onNCRInfomationSave = async () => {
    const isValid = await this.ncrInformation.current.submitForm();

    if (!isValid) {
      message.error("Please fix errors.");
      return;
    }

    const formData = this.state.ncrInformationData;

    const { kalamAndKayda, ...restValues } = formData;

    const ncrInformationData = {
      ...restValues,
      masterId: this.state.isAccusedFormEdit?.[0]?.editId,
      userId: this.props.user?.id,
      cityId: this.props.user?.cityId,
    };

    const data = {
      ncrInformationData,
      kaydkalam: kalamAndKayda,
      currentuser: this.props.user,
    };

    NCRServiceAction.addNCR(data);

    message.success("Saved Successfully!");
    this.onNcrDrawerClose();
    this.onCloseNCRnumber();
    this.ncrInformation.current.resetForm();
  };

  onPreventiveInfomationSave = async () => {
    const values = await this.preventiveInfoRef.current.onFinish();

    if (!values) {
      message.error("Please fix the validation errors before saving.");
      return; // stop execution if invalid
    }

    this.preventiveInfoRef.current.onFinish(true);
    console.log(
      "preventiveInformationData save",
      this.state.preventiveInformationData,
    );
    console.log(
      "newpreventiveInformationData",
      this.state.newpreventiveInformationData,
    );
    console.log("values", values);
    setTimeout(() => {
      let data = {
        preventiveInformationData: {
          ...values,
          date_from: values.date_from
            ? moment(values.date_from).format("YYYY-MM-DD")
            : null,
          date_to: values.date_to
            ? moment(values.date_to).format("YYYY-MM-DD")
            : null,
          date_issue_bond: values.date_issue_bond
            ? moment(values.date_issue_bond).format("YYYY-MM-DD")
            : null,
          proposal_sent_date: values.proposal_sent_date
            ? moment(values.proposal_sent_date).format("YYYY-MM-DD")
            : null,
          chaptorCaseYear: values.chaptorCaseYear
            ? moment(values.chaptorCaseYear).format("YYYY")
            : null,
          tadipar_unit: values.tadipar_unit
            ? values.tadipar_unit.toString()
            : null,
          orderFIle: values.orderFIle ? values.orderFIle : null,
          orderType: values.orderType ? values.orderType : null,
          masterId: this.state.isAccusedFormEdit[0].editId,

          userId: this.props.user && this.props.user.id,
          city: this.props?.user?.cityId,
          district: this.props?.user?.districtId,
          districtName: values.action_taken_police_station,
        },
        currentuser: { ...this.props.user },
      };
      if (this.props?.user?.cityId) {
        this.props.dispatch(professionalAction.createPreventiveAction(data));
        message.info("Save Successfully !!");
        this.onpreventiveDrawerClose();
        this.onClosePreventiveAccusedDrawer();
        this.preventiveInfoRef.current.resetForm();
        setTimeout(() => {
          this.getPreventiveActionsByDateAndId(
            this.state.isAccusedFormEdit[0].editId,
          );
        }, 2000);
      } else {
        message.warning("somthin wrong...");
      }
      // rest unchanged...
    }, 500);
  };

  onPreventiveInfomationUpdate = async () => {
    const values = await this.preventiveInfoRef.current.onFinish();
    console.log("values edit", values);

    if (!values) {
      message.error("Please fix the validation errors before saving.");
      return; // stop execution if invalid
    }

    this.preventiveInfoRef.current.onFinish(true);

    console.log(
      "preventiveInformationData save",
      this.state.preventiveInformationData[0],
    );
    setTimeout(() => {
      let data = {
        preventiveInformationData: {
          ...values,
          date_from: values.date_from
            ? moment(values.date_from).format("YYYY-MM-DD")
            : null,
          date_to: values.date_to
            ? moment(values.date_to).format("YYYY-MM-DD")
            : null,
          date_issue_bond: values.date_issue_bond
            ? moment(values.date_issue_bond).format("YYYY-MM-DD")
            : null,
          proposal_sent_date: values.proposal_sent_date
            ? moment(values.proposal_sent_date).format("YYYY-MM-DD")
            : null,
          chaptorCaseYear: values.chaptorCaseYear
            ? moment(values.chaptorCaseYear).format("YYYY")
            : null,
          tadipar_unit: values.tadipar_unit
            ? values.tadipar_unit.toString()
            : null,
          orderFIle: values.orderFIle ? values.orderFIle : null,
          orderType: values.orderType ? values.orderType : null,
          masterId: this.state.isAccusedFormEdit[0].editId,
          userId: this.props.user && this.props.user.id,
          action_taken_police_station: values.action_taken_police_station,
          city: this.props?.user?.cityId,
          district: this.props?.user?.districtId,
          districtName: values.action_taken_police_station,
        },
        currentuser: { ...this.props.user },
      };
      if (this.props?.user?.cityId) {
        this.props.dispatch(
          professionalAction.updatePreventive(
            this.state.editPreventiveInformationData[0].id,
            data,
          ),
        );
        message.info("Update Successfully !!");
        this.onpreventiveDrawerClose();
        this.onClosePreventiveAccusedDrawer();
        setTimeout(() => {
          this.getPreventiveActionsByDateAndId(
            this.state.isAccusedFormEdit[0].editId,
          );
        }, 2000);
        this.setState({ preventiveInformationData: [] });
      } else {
        message.warning("Something wrong");
      }

      // rest unchanged...
    }, 500);
  };

  onPreventiveViewAccusedForm = (data) => {
    this.setState({ preventiveInformationData: [] });
    professionalAction.getPreventiveToolByID(data).then((res) => {
      res &&
        res.text().then((criminalList) => {
          this.setState({
            preventiveInformationData: criminalList && JSON.parse(criminalList),
          });
        });
    });

    this.setState({
      userID: data.userId,
    });

    this.setState({
      isAccusedFormEdit: [
        {
          editId: data,
          isEdit: true,
        },
      ],
      isEditForms: true,
      accusedPreventiveDrawer: true,
      newPreventive: false,
      resetBasicForm: false,
      newflag: 1,
    });
  };

  onNCRViewAccusedForm = (data) => {
    this.setState({ ncrInformationData: [] });
    let obj = {
      masterId: data,
    };
    NCRServiceAction.getNCRByMaster(obj).then((res) => {
      res &&
        res.text().then((criminalList) => {
          let criminal = JSON.parse(criminalList);
          let list = criminal.data;
          console.log("criminalList", list);

          this.setState({
            ncrInformationData: list,
          });
        });
    });
    this.setState({
      ncrShow: true,
      isAccusedFormEdit: [
        {
          editId: data,
          isEdit: true,
        },
      ],
    });
  };
  onCriminalActiveStatus = (data) => {
    if (data) {
      this.setState({
        criminalActiveModel: true,
        criminalActiveData: data,
      });
    }
  };

  onCriminalActiveStatusCancel = () => {
    this.setState({
      criminalActiveModel: false,
      criminalActiveData: {},
    });
  };

  onCriminalActiveStatusChange = () => {
    let data = {
      activeUser: this.state.criminalActiveData.activeUser === 1 ? 0 : 1,
      activeStatusReason: this.state.criminalActiveReasoneValue,
    };

    if (this.state.criminalActiveData && this.state.criminalActiveData.id) {
      professionalAction
        .updateCriminalActiveStatus(this.state.criminalActiveData.id, data)
        .then((res) => {
          this.getData();
          this.setState({
            criminalActiveModel: false,
            activeStatusReason: "",
          });
        });
    }
  };

  onCriminalActiveInputChange = (evt) => {
    this.setState({
      criminalActiveReasoneValue: evt.target.value,
    });
  };

  onChangeText = (values) => {
    if (values) {
      this.setState({
        findTextValue: values,
      });
    }
  };

  onChangeNumber = (values) => {
    if (values) {
      this.setState({
        findNumberValue: values.target.value,
      });
    }
  };

  showDownloadModel = () => {
    this.setState({ download_modal: true });
  };

  closeDownloadModel = () => {
    this.setState({ download_modal: false });
  };

  handleAllCheckboxChange = () => {
    this.setState((prevState) => ({
      all: !prevState.all, // Toggle the all state
    }));
  };

  handleCheckboxNameChange = (e) => {
    this.setState((prevState) => ({
      name: !prevState.name,
    }));
  };

  handleCheckboxAddress = (e) => {
    this.setState((prevState) => ({
      address: !prevState.address,
    }));
  };

  hanldeCheckboxMobileNumber = (e) => {
    this.setState((prevState) => ({
      mobileNumber: !prevState.mobileNumber,
    }));
  };

  handleCheckboxCity = (e) => {
    this.setState((prevState) => ({
      city: !prevState.city,
    }));
  };

  hanldeCheckboxState = (e) => {
    this.setState((prevState) => ({
      state_name: !prevState.state_name,
    }));
  };

  handleCheckboxdistrictName = (e) => {
    this.setState((prevState) => ({
      district_name: !prevState.district_name,
    }));
  };

  handleCheckboxReligion = (e) => {
    this.setState((prevState) => ({
      religion: !prevState.religion,
    }));
  };

  handleCheckboxCriminalProfile = (e) => {
    this.setState((prevState) => ({
      criminal_profile: !prevState.criminal_profile,
    }));
  };

  handleCheckboxGunhaCount = (e) => {
    this.setState((prevState) => ({
      gunhaCount: !prevState.gunhaCount,
    }));
  };

  hanldeCheckboxAge = (e) => {
    this.setState((prevState) => ({
      age: !prevState.age,
    }));
  };

  handleCheckboxdharms = (e) => {
    this.setState((prevState) => ({
      dharms: !prevState.dharms,
    }));
  };

  showBasicForm = () => {
    this.setState({
      newflag: 1,
    });
  };
  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };

  onViewAccusedForm = (data) => {
    if (data) {
      this.showCriminalViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  onCriminalActiveStatus = (data) => {
    if (data) {
      this.setState({
        criminalActiveModel: true,
        criminalActiveData: data,
      });
    }
  };

  onEditAccusedForm = (data) => {
    console.log("data ids", data);
    this.setState({
      userID: data.userId,
    });
    const ID = this.state.searchType === "crime" ? data?.masterId : data?.id;
    this.setState({
      masterId: ID,
    });
    let temo = this.props.dispatch(professionalAction.getCriminalsById(ID));

    temo.then((res) => {
      const {
        basicInfo,
        gunhaInfor,
        otherInfo,
        wantedHistory,
        document_verified,
      } = res;
      // let getEditGunhaTemp = _.filter(gunhaInfor, (o) => {
      //   return o.masterId === data.id;
      // });
      // let getEditOtherTemp = _.filter(otherInfo, (o) => {
      //   return o.masterId === data.id;
      // });
      let getEditGunhaTemp = _.filter(gunhaInfor, (o) => {
        return o.masterId === ID;
      });
      let getEditOtherTemp = _.filter(otherInfo, (o) => {
        return o.masterId === ID;
      });
      this.setState({
        basicInformationData: basicInfo,
        isAccusedFormEdit: [
          {
            // editId: data.id,
            editId: ID,
            guhnhaEditId: getEditGunhaTemp[0] && getEditGunhaTemp[0].id,
            otherEditId: getEditOtherTemp[0] && getEditOtherTemp[0].id,
            isEdit: true,
          },
        ],
        ghunhaInfomationData: [...getEditGunhaTemp],
        otherInformationData: [...getEditOtherTemp],
        isEditForms: true,
        accusedDrawer: true,
        newGunha: false,
        resetBasicForm: false,
        newflag: 1,
        wantedHistory: wantedHistory,
        is_document_verified: document_verified,
      });
    });
  };
  getSerialNumber = (index, currentPage, itemsPerPage) => {
    return currentPage * itemsPerPage + index + 1;
  };
  handleSortByChange = (value) => {
    const { searchType } = this.state;
    this.setState(
      {
        sortBy: value,
      },
      () => {
        if (this.state.is_search === true) {
          if (this.props.user.role === "4" && searchType != "crime") {
            this.handleNameTypeSearch();
          } else {
            this.handleSearch();
          }
        }

        if (this.state.is_filter === true) {
          if (this.state.activeFilter === "search") {
            this.handleSearchFilter();
          } else {
            this.sortbyFilter();
          }
        }
        if (!this.state.is_search && !this.state.is_filter) {
          this.getData();
        }
      },
    );
  };

  handleSortOrderChange = (value) => {
    const { searchType } = this.state;
    this.setState(
      {
        sortOrder: value,
      },
      () => {
        if (this.state.is_search === true) {
          if (this.props.user.role === "4" && searchType != "crime") {
            this.handleNameTypeSearch();
          } else {
            this.handleSearch();
          }
        }
        if (this.state.is_filter === true) {
          if (this.state.activeFilter === "specific") {
            this.handleSearchFilter();
          } else {
            this.sortbyFilter();
          }
        }
        if (!this.state.is_search && !this.state.is_filter) {
          this.getData();
        }
      },
    );
  };

  downloadCriminalAlbumHTML = (crimeAlbumid, criminal) => {
    const {
      year,
      advancedFilterTitle,
      crimeTitle,
      selectedHeadings,
      main_head,
      kayda,
      kalam,
    } = this.state;
    console.log("this.props.professionals", this.props.professionals);

    let criminals = criminal.filter((crim) => crim.photo && crim.photo !== "");
    const role = this.props.user.role;
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const city = this.getCityName(this.props.user.cityId);
    const cityName =
      this.props?.user?.role === "2" ? `${stateName} (${city})` : city;

    const type =
      advancedFilterTitle === "मोडस"
        ? "मोडस ऑपरेंडी"
        : advancedFilterTitle === "कायदा"
          ? "कायदा व कलम"
          : advancedFilterTitle;

    const yearValue = Array.isArray(year)
      ? year.filter(Boolean).join(", ")
      : year || "";

    const created_date = moment().format("DD MMM YYYY");

    const crimeTypes = this.props.professionals.pc_crimetypes || [];
    const crimeTitleIds = crimeTitle || [];

    const crimeTypeNames = crimeTitleIds
      .map((id) => crimeTypes.find((item) => item.id === id)?.crimetype)
      .filter(Boolean);

    const crimetitles = this.props.professionals.pc_crimetitles || [];
    const headingNames = selectedHeadings
      .map((id) => crimetitles.find((item) => item.id === id)?.crime_title)
      .filter(Boolean);

    const modasNames = crimeTitleIds
      .map((id) => main_head.find((item) => item.id === id)?.main_head_type)
      .filter(Boolean);

    const acts = this.props.professionals?.pc_acts || [];
    const actsName = acts.find((item) => item.id === kayda)?.kayda;

    const sections = this.props.professionals?.pc_kalams || [];
    const sectionsNames = kalam
      .map((id) => sections.find((item) => item.section === id)?.section)
      .filter(Boolean);

    const fullKayda = `${actsName}-${sectionsNames.join(", ")}`;

    const list_type =
      advancedFilterTitle === "लघु शीर्षक"
        ? crimeTypeNames.join(", ")
        : advancedFilterTitle === "शीर्षक"
          ? headingNames.join(", ")
          : advancedFilterTitle === "मोडस"
            ? modasNames.join(", ")
            : advancedFilterTitle === "कायदा"
              ? fullKayda
              : "";

    const districts = this.props.professionals.basicDistricts || [];
    console.log("districts", districts);
    let paramter = {
      search_type: type,
      list_type: list_type,
      year: yearValue ? yearValue : "",
      cityName: cityName,
    };
    const temp = {
      user_id: this.props.user.id,
      parameter: paramter,
      album_id: crimeAlbumid,
    };
    adminService.crimeAlbumLog(temp).then((res) => {
      console.log("res", res);
    });
    if (crimeAlbumid) {
      const html = `
<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8" />
<meta
      name="viewport"
      content="width=device-width, initial-scale=1, shrink-to-fit=no"
    />
<title>Criminal Digital Album</title>

<link href="https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;600;700&display=swap" rel="stylesheet">
<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css" rel="stylesheet">
<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/js/bootstrap.bundle.min.js"></script>
<style>
    html {
      display: block;
    }

    footer {
      margin-top: auto;
      /* Push footer to bottom */
    }

    * {
      font-family: "Noto Sans Devanagari", sans-serif;
    }

    body {
      background: #f4f6fb;
    }

    footer {
      margin-top: 30px;
      padding: 14px 16px;
      text-align: center;
      background: white;
      border-top: 1px solid #e5e7eb;
      font-size: 14px;
      color: #555;
    }

    .footer-content {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 8px;
      align-items: center;
    }

    footer a {
      color: #1677ff;
      text-decoration: none;
      font-weight: 600;
    }

    footer a:hover {
      text-decoration: underline;
    }

    /* HEADER */
    .header-bar {
      display: grid;
      grid-template-columns: 1fr auto;
      align-items: center;
      background: linear-gradient(135deg, #1e3a8a, #2563eb);
      color: white;
      padding: 18px 24px;
      border-radius: 14px;
      margin: 16px;
      box-shadow: 0 8px 22px rgba(0, 0, 0, 0.18);
      position: relative;
    }

    /* TRUE CENTER ALIGNMENT */
    .header-center {
      text-align: center;
      justify-self: center;
      width: 100%;
    }

    /* RIGHT LOGO */
    .header-right {
      justify-self: end;
    }


    /* GOVERNMENT STYLE TEXT */
    .animated-text {
      display: inline-block;
      font-size: 17px;
      font-weight: 700;
      margin-top: 6px;
      color: #e0f2fe;
      letter-spacing: 0.4px;
      animation: glow 2.2s infinite alternate;
    }

    /* Glow animation */
    @keyframes glow {
      from {
        text-shadow: 0 0 4px #60a5fa, 0 0 10px #2563eb;
        transform: scale(1);
      }

      to {
        text-shadow: 0 0 10px #93c5fd, 0 0 18px #3b82f6;
        transform: scale(1.02);
      }
    }

    /* RIGHT LOGO */
    .header-right {
      display: flex;
      justify-content: flex-end;
    }

    .header-right img {
      max-height: 70px;
      border-radius: 10px;
      background: white;
      padding: 6px;
      border: 1px solid gold;
      transition: transform 0.3s ease;
    }

    .header-right img:hover {
      transform: scale(1.05);
    }


    /* Responsive */
    @media (max-width: 768px) {
      .header-bar {
        grid-template-columns: 1fr;
        text-align: center;
        gap: 10px;
      }

      .header-left,
      .header-right {
        justify-content: center;
      }

      .filter-box {
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
      }

      .filter-box .count {
        margin-left: 0;
        align-self: flex-end;
        /* right align count */
      }
    }


    /* FILTER TAGS */
    .filter-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 14px;
      font-size: 14px;
      background: white;
      padding: 12px 16px;
      border-radius: 12px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .06);
      margin: 0 16px 14px;
      flex-wrap: wrap;
      /* allow wrapping */
    }

    /* Left text inline */
    .filter-box span {
      font-weight: 600;
      color: #1e3a8a;
      white-space: nowrap;
    }

    /* Right total photos */
    .filter-box .count {
      margin-left: auto;
      font-weight: 700;
      color: #2563eb;
      white-space: nowrap;
    }


    /* FILTER BAR */
    .filter-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      background: white;
      padding: 12px 14px;
      border-radius: 10px;
      margin: 0 16px 18px;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .06);
      flex-wrap: nowrap;
    }

    .filter-right {
      display: flex;
      gap: 12px;
      align-items: center;
    }



    .filter-bar input {
      padding: 8px 12px;
      border-radius: 8px;
      border: 1px solid #d9d9d9;
      font-size: 14px;
      text-align: center;
      /* min-width: 200px; */
      /* height: 38px; */
    }


    /* GRID */
    .grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
      gap: 16px;
      margin: 0 16px;
    }

    /* CARD */
    .card {
      background: white;
      border-radius: 14px;
      overflow: hidden;
      border: 2px solid #e5e7eb;
      transition: .2s;
      border: 3px solid #d400ff;
    }

    .card:hover {
      transform: translateY(-4px);
      box-shadow: 0 12px 22px rgba(0, 0, 0, .12);
    }

    /* IMAGE */
    .image-wrap {
      position: relative;
    }

    .card img {
      width: 100%;
      height: 230px;
      object-fit: cover;

    }

    /* BADGE */
    .badge {
      position: absolute;
      top: 8px;
      right: 8px;
      background: #dc2626;
      color: white;
      font-weight: bold;
      font-size: 13px;
      padding: 4px 10px;
      border-radius: 20px;
    }

    /* INFO */
    .info {
      padding: 12px;
      font-size: 14px;
    }

    .name {
      font-size: 16px;
      font-weight: 700;
      color: #1e3a8a;
      margin-bottom: 6px;
    }

    /* PAGINATION */
    .pagination-wrapper {
      display: flex;
      justify-content: center;
      gap: 12px;
      margin: 22px 16px;
      flex-wrap: wrap;
    }

    .pagination button {
      padding: 6px 12px;
      border-radius: 6px;
      border: 1px solid #d9d9d9;
      cursor: pointer;
    }

    .pagination button.active {
      background: #1677ff;
      color: white;
    }

    /* Compact AntD Multi Select */
    .antd-multiselect {
      min-width: 260px;
      position: relative;
    }

    #searchInput {
      min-width: 220px;
      border-radius: 4px;
      border: 2px solid #6b7280;
      background: #fff;
      padding: 8px 12px;
      min-height: 42px;
      font-weight: 600;
    }

    .modal-header {
      background: #f8fafc;
      border-bottom: 1px solid #e5e7eb;
    }

    .modal-title {
      font-weight: 600;
      color: #1e3a8a;
    }


    .antd-input {
      border-radius: 4px;
      border: 2px solid #6b7280;
      background: #fff;
      padding: 8px 12px;
      min-height: 42px;
      font-weight: 600;
    }

    /* Hover */
    .antd-input:hover {
      border-color: #1e3a8a;
    }

    /* Focus */
    .antd-input:focus-within {
      border-color: #1e3a8a;
      box-shadow: 0 0 0 2px rgba(30, 58, 138, .2);
    }


    .antd-tags {
      display: flex;
      align-items: center;
      gap: 4px;
      overflow: hidden;
    }

    .antd-tag {
      background: #f0f5ff;
      border: 1px solid #adc6ff;
      color: #1d39c4;
      padding: 3px 8px;
      border-radius: 999px;
      font-size: 12px;
      font-weight: 600;
      display: flex;
      align-items: center;
      white-space: nowrap;
    }


    .antd-tag button {
      border: none;
      background: transparent;
      cursor: pointer;
      font-size: 12px;
      color: #666;
    }

    #districtSearch {
      border: none;
      outline: none;
      font-size: 13px;
      flex: 1;
      min-width: 80px;
      height: 22px;
    }

    /* Dropdown */
    .antd-dropdown {
      display: none;
      position: absolute;
      top: calc(100% + 6px);
      left: 0;
      right: 0;
      width: 100%;
      max-height: 260px;
      overflow-y: auto;
      background: white;
      border-radius: 12px;
      border: 1px solid #e5e7eb;
      box-shadow: 0 12px 28px rgba(0, 0, 0, .16);
      z-index: 9999;
      padding: 6px 0;
    }

    .antd-dropdown::-webkit-scrollbar {
      width: 6px;
    }

    .antd-dropdown::-webkit-scrollbar-thumb {
      background: #c7d2fe;
      border-radius: 10px;
    }


    /* Option Row */
    .antd-option {
      padding: 9px 12px;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 10px;
      border-bottom: 1px solid #f0f0f0;
      transition: background .15s ease, transform .05s ease;
      line-height: 1.4;
    }

    .antd-option.selected {
      background: #eef4ff;
      font-weight: 600;
    }


    .antd-option:last-child {
      border-bottom: none;
    }

    .antd-option:hover {
      background: #f5f8ff;
    }

    .antd-option input {
      transition: transform .08s ease;
    }

    .antd-option input:checked {
      transform: scale(1.1);
    }

    /* PREMIUM SLIDER MODE */
    /* PREMIUM SLIDER MODE */
    .slider {
      display: flex;
      justify-content: center;
      margin: 26px 16px;
    }

    /* Desktop Slider Card */
    .slider-card {
      width: 100%;
      max-width: 620px;
      background: white;
      border-radius: 18px;
      border: 3px solid #7c3aed;
      overflow: hidden;
      box-shadow: 0 14px 28px rgba(0, 0, 0, .18);
      transition: .3s ease;
    }

    /* Desktop Image */
    .slider-card img {
      width: 100%;
      height: 420px;
      object-fit: contain;
      background: #f9fafb;
      border-bottom: 1px solid #eee;
    }

    /* Info section */
    .slider-card .info {
      padding: 16px;
      font-size: 15px;
    }

    /* SLIDER CONTROLS */
    .slider-controls {
      display: grid;
      grid-template-columns: auto 1fr auto;
      align-items: center;
      gap: 14px;
      padding: 12px 16px;
      background: white;
      border-top: 1px solid #e5e7eb;
      box-shadow: 0 -6px 18px rgba(0, 0, 0, .08);
    }

    /* Slide Counter */
    .slider-controls span {
      text-align: center;
      font-weight: 700;
      color: #6d28d9;
      font-size: 14px;
    }

    /* Buttons */
    .slider-controls button {
      padding: 8px 16px;
      border-radius: 10px;
      border: 1px solid #ddd;
      background: #fafafa;
      color: #4f46e5;
      font-weight: 700;
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      transition: all .18s ease;
    }

    /* Hover */
    .slider-controls button:hover {
      background: #4f46e5;
      color: white;
      transform: translateY(-1px);
      box-shadow: 0 6px 14px rgba(79, 70, 229, .35);
    }

    .slider-btn {
      border: 2px solid #7c3aed;
      background: white;
      color: #7c3aed;
      padding: 10px 14px;
      border-radius: 12px;
      font-weight: 700;
      transition: .2s ease;
    }

    .slider-btn.primary {
      background: #7c3aed;
      color: white;
    }

    .slider-btn:hover {
      transform: scale(1.04);
      box-shadow: 0 4px 12px rgba(124, 58, 237, .35);
    }

    /* THUMBNAILS */
    .thumbnail-strip {
      display: flex;
      gap: 10px;
      padding: 12px;
      overflow-x: auto;
      background: #f8fafc;
      border-top: 1px solid #e5e7eb;
    }

    .thumbnail-strip img {
      width: 72px;
      height: 72px;
      object-fit: cover;
      border-radius: 10px;
      cursor: pointer;
      opacity: 0.55;
      border: 2px solid transparent;
      transition: .2s ease;
    }

    .thumbnail-strip img.active {
      opacity: 1;
      border-color: #7c3aed;
      transform: scale(1.08);
    }

    /* ===== MOBILE FULL WIDTH MODE ===== */
    @media (max-width: 768px) {
      .filter-bar {
        flex-wrap: wrap;
      }

      .filter-right {
        flex-direction: column;
        width: 100%;
      }

      .antd-multiselect,
      #searchInput {
        min-width: 100%
      }

      .slider {
        margin: 10px 0;
        padding: 1rem;
      }

      .slider-card {
        width: 100%;
        border-radius: 0;
        border-top: 4px solid #7c3aed;
        border-bottom: 4px solid #7c3aed;
        box-shadow: 0 6px 16px rgba(0, 0, 0, .12);
        display: flex;
        flex-direction: column;
      }

      /* Image auto height — NO vh */
      .slider-card img {
        width: 100%;
        height: auto;
        max-height: 520px;
        object-fit: contain;
        background: #000;
      }

      .slider-card .thumbnail-strip img {
        width: 60px;
        height: 60px;
        max-height: auto;
      }

      .slider-card .info {
        padding: 14px 16px;
        font-size: 15px;
      }

      .slider-controls {
        padding: 12px;
        background: white;
        border-top: 1px solid #e5e7eb;
      }

      .thumbnail-strip {
        padding-bottom: 12px;
      }
    }





    .view-toggle-wrap {
      display: flex;
      align-items: center;
      gap: 10px;
      font-weight: 600;
      white-space: nowrap;
    }


    /* ANT STYLE SWITCH */
    .antd-switch {
      position: relative;
      display: inline-block;
      width: 46px;
      height: 24px;
    }

    .antd-switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider-round {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #d9d9d9;
      transition: 0.25s;
      border-radius: 50px;
    }

    .slider-round:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: 0.25s;
      border-radius: 50%;
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
    }

    .antd-switch input:checked+.slider-round {
      background-color: #1677ff;
    }

    .antd-switch input:checked+.slider-round:before {
      transform: translateX(22px);
    }

    /* MOBILE */

    @media (max-width: 768px) {
      .header-bar {
        display: flex !important;
        /* Override grid */
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 12px;
      }

      .header-center {
        order: 1;
        width: 100%;
      }

      .header-right {
        order: 2;
        width: 100%;
        display: flex;
        justify-content: center;
        /* Center logo */
      }

      .header-right img {
        max-height: 55px;
      }

    }
  </style>
</head>

<body>

 <div class="header-bar">
            <div class="header-center">
                <h2>
                    Digital Album <br>
                    <span class="animated-text">Criminal Monitoring Intelligent System</span>
                </h2>
            </div>

            <div class="header-right">
                <a href="https://www.criminalmis.in/" target="_blank">
                    <img src="https://pcimageupload.s3.amazonaws.com/pc_cmis_logo-1770633708525.jpeg">
                </a>
            </div>
        </div>
        <div 
  style="text-align:right; margin:10px; font-weight:700; color:#1e3a8a;" 
  id="criminal_id"
  data-album-id="${crimeAlbumid}">
  Album Reference ID: ${crimeAlbumid}
</div>


<div class="filter-box">
  ${
    cityName
      ? `<span><strong>${
          role == 2 ? "पोलिस ठाणे;" : "घटक"
        } :</strong> ${cityName}</span>`
      : ""
  }
  ${
    type
      ? `<span><strong>गुन्ह्याची पद्धती:</strong> ${type} (${list_type})</span>`
      : ""
  }
  ${yearValue ? `<div><span>वर्ष:</span> ${yearValue}</div>` : ""}
  <div class="count">Total Photos: <strong>${criminals.length}</strong></div>
  
</div>

 <div class="filter-bar">

    <!-- LEFT -->
    <div class="view-toggle-wrap">
      <span id="viewLabel">Grid View</span>

      <label class="antd-switch">
        <input type="checkbox" id="viewToggle">
        <span class="slider-round"></span>
      </label>

      <span id="viewLabelRight">Slide View</span>
    </div>

    <!-- RIGHT -->
    <div class="filter-right">
      <div class="antd-multiselect" style="${role == 2 ? "display:none;" : ""}">
        <div class="antd-input" id="districtToggle">
          <div class="antd-tags" id="selectedTags"></div>
          <input type="text" id="districtSearch" placeholder="Police Station" />
        </div>

        <div class="antd-dropdown" id="districtList"></div>
      </div>

      <input type="text" id="searchInput" placeholder="Search Name..." />
    </div>

  </div>

<div id="pagesContainer"></div>

<div class="pagination-wrapper" id="paginationWrapper">
  <div class="pagination" id="pagination"></div>
  <select id="pageSizeSelect">
    <option value="50">50 / page</option>
    <option value="100">100 / page</option>
    <option value="150">150 / page</option>
  </select>
</div>

<!-- Image Preview Modal -->
<div class="modal fade" id="imageModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <!-- Header with Close Button -->
      <div class="modal-header py-2">
        <h6 class="modal-title">Image Preview</h6>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <!-- Body -->
      <div class="modal-body p-2 text-center">
        <img id="modalImage" src="" style="width:100%; border-radius:10px; max-height:75vh; object-fit:contain;" />
      </div>

    </div>
  </div>
</div>


 <footer>
    <div class="footer-content"><a href="https://www.criminalmis.in/" target="_blank"> www.criminalmis.in
      </a> </div>
  </footer>

<script>
const crimeAlbumId = document
  .getElementById("criminal_id")
  .dataset.albumId;

console.log(crimeAlbumId);
window.onload = function () {

  fetch("https://v2api.criminalmis.in/api/criminal/crime-album-access", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      album_id: crimeAlbumId,
      type:"आरोपी शोधा"
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log("Access log saved", data);
  })
  .catch(error => {
    console.error("Error logging access", error);
  });

};

let viewMode = "grid"; // grid | slider
let sliderIndex = 0;

let currentPage = 0;
let pageSize = 50;

const criminals = ${JSON.stringify(criminals)};
const districts = ${JSON.stringify(districts)};



const pagesContainer = document.getElementById("pagesContainer");
    const districtList = document.getElementById("districtList");
    const districtToggle = document.getElementById("districtToggle");
    const selectedTags = document.getElementById("selectedTags");
    const districtSearch = document.getElementById("districtSearch");

    function applyFilters() {
      const search = document.getElementById("searchInput").value.toLowerCase();

      filteredData = criminals.filter(c => {

        // Multi district filter
        const matchesDistrict =
          selectedDistricts.length === 0 ||
          selectedDistricts.includes(c.districtName);

        // Global criminal search filter
        const matchesSearch =
          !search ||
          Object.values(c)
            .join(" ")
            .toLowerCase()
            .includes(search);

        return matchesDistrict && matchesSearch;
      });

      currentPage = 0;
      renderPage();
      renderPagination();
    }

    let selectedDistricts = [];

    // Open dropdown
    districtToggle.addEventListener("click", () => {
      districtList.style.display = "block";
      districtSearch.focus();
    });

    // Close outside click
    document.addEventListener("click", (e) => {
      const clickedInside =
        districtToggle.contains(e.target) ||
        districtList.contains(e.target);

      if (!clickedInside) {
        districtList.style.display = "none";
      }
    });


    // Render options
    function renderOptions(filter = "") {
      districtList.innerHTML = "";

      districts
        .filter(d => d.DistrictName.toLowerCase().includes(filter.toLowerCase()))
        .forEach(d => {
          const div = document.createElement("div");
          div.className = "antd-option";

          const checked = selectedDistricts.includes(d.DistrictName);

          div.innerHTML = \`
        <input type="checkbox" \${checked ? "checked" : ""}>
        <span>\${d.DistrictName}</span>
      \`;

          div.addEventListener("click", (e) => {
            e.stopPropagation(); // 🔥 prevents dropdown close
            toggleDistrict(d.DistrictName);
          });


          districtList.appendChild(div);
        });
    }

    // Toggle select
    function toggleDistrict(name) {
      if (selectedDistricts.includes(name)) {
        selectedDistricts = selectedDistricts.filter(x => x !== name);
      } else {
        selectedDistricts.push(name);
      }

      renderTags();
      renderOptions(districtSearch.value);
      applyFilters();
    }

    // Render tags
    function renderTags() {
      selectedTags.innerHTML = "";

      const visible = selectedDistricts.slice(0, 2);
      const extraCount = selectedDistricts.length - visible.length;

      visible.forEach(name => {
        const tag = document.createElement("div");
        tag.className = "antd-tag";
        tag.innerHTML = \`
      \${name}
      <button onclick="removeDistrict('\${name}')">×</button>
    \`;
        selectedTags.appendChild(tag);
      });

      if (extraCount > 0) {
        const more = document.createElement("div");
        more.className = "antd-tag";
        more.innerText = \`+\${extraCount}...\`;
        selectedTags.appendChild(more);
      }
    }

    // Remove tag
    function removeDistrict(name) {
      selectedDistricts = selectedDistricts.filter(x => x !== name);
      renderTags();
      renderOptions();
      applyFilters();
    }

    // Search filter
    districtSearch.addEventListener("input", (e) => {
      renderOptions(e.target.value);
    });

    function openImageModal(src) {
      const modalImg = document.getElementById("modalImage");
      modalImg.src = src;

      const modal = new bootstrap.Modal(document.getElementById("imageModal"));
      modal.show();
    }


    function nextSlide() {
      sliderIndex++;
      if (sliderIndex >= filteredData.length) sliderIndex = 0;
      renderPage();
    }

    function prevSlide() {
      sliderIndex--;
      if (sliderIndex < 0) sliderIndex = filteredData.length - 1;
      renderPage();
    }





    function enableSwipe() {
      const card = document.getElementById("sliderCard");
      if (!card) return;

      let startX = 0;

      card.addEventListener("touchstart", (e) => {
        startX = e.touches[0].clientX;
      });

      card.addEventListener("touchend", (e) => {
        let endX = e.changedTouches[0].clientX;
        let diff = startX - endX;

        if (diff > 60) nextSlide();      // swipe left
        if (diff < -60) prevSlide();     // swipe right
      });
    }

    document.getElementById("viewToggle").addEventListener("click", () => {
      viewMode = viewMode === "grid" ? "slider" : "grid";
      sliderIndex = 0;

      document.getElementById("viewToggle").innerText =
        viewMode === "grid" ? "Switch to Slide View" : "Switch to Normal View";

      // Show pagination ONLY in grid mode
      document.getElementById("paginationWrapper").style.display =
        viewMode === "grid" ? "flex" : "none";

      renderPage();
    });


    function renderThumbnails() {
      const strip = document.getElementById("thumbnailStrip");
      if (!strip) return;

      strip.innerHTML = "";

      filteredData.forEach((item, index) => {
        const thumb = document.createElement("img");
        thumb.src = \`https://pcimageupload.s3.ap-south-1.amazonaws.com/\${item.photo}\`;

        if (index === sliderIndex) {
          thumb.classList.add("active");
        }

        thumb.onclick = () => {
          sliderIndex = index;
          renderPage();
        };

        strip.appendChild(thumb);
      });
    }

    // Render only current page
    function renderPage() {
      pagesContainer.innerHTML = "";

      const start = currentPage * pageSize;
      const end = start + pageSize;
      const pageItems = filteredData.slice(start, end);

      // GRID MODE (DEFAULT)
      if (viewMode === "grid") {
        const grid = document.createElement("div");
        grid.className = "grid";

        pageItems.forEach(c => {
          const card = document.createElement("div");
          card.className = "card";

          card.innerHTML = \`
        <div class="image-wrap">
          <img src="https://pcimageupload.s3.ap-south-1.amazonaws.com/\${c.photo}" onclick="openImageModal(this.src)" />
          <div class="badge">एकुण गुन्हे: \${c.gunhaCount || c.totalCrimeCount || 0}</div>
        </div>

        <div class="info">
          <div class="name">\${c.name || "-"}</div>
          <p><strong>CMIS ID:</strong>\${c.id || "-"}</p>
          <p><strong>पत्ता:</strong>\${c.address || "-"}</p>
          <p><strong>पोलिस ठाणे:</strong>\${c.districtName || "-"}</p>
        </div>
      \`;

          grid.appendChild(card);
        });

        pagesContainer.appendChild(grid);
        return;
      }

      // SLIDER MODE
      // SLIDER MODE
      const c = filteredData[sliderIndex];
      if (!c) return;

      const slider = document.createElement("div");
      slider.className = "slider";

      slider.innerHTML = \`
  <div class="slider-card" id="sliderCard">

    <div class="image-wrap">
      <img src="https://pcimageupload.s3.ap-south-1.amazonaws.com/\${c.photo}" onclick="openImageModal(this.src)" />
      <div class="badge">एकुण गुन्हे: \${c.gunhaCount || c.totalCrimeCount || 0}</div>
    </div>

    <div class="info">
      <div class="name">\${c.name || "-"}</div>
      <p><strong>CMIS ID:</strong> \${c.id || "-"}</p>
      <p><strong>पत्ता:</strong> \${c.address || "-"}</p>
      <p><strong>पोलिस ठाणे:</strong> \${c.districtName || "-"}</p>
    </div>

    <div class="slider-controls">
      <button class="slider-btn"  onclick="prevSlide()">⬅ Previous</button>
      <span style="font-weight:600">\${sliderIndex + 1} / \${filteredData.length}</span>
      <button class="slider-btn primary" onclick="nextSlide()">Next ➡</button>
    </div>

    <!-- THUMBNAILS -->
    <div class="thumbnail-strip" id="thumbnailStrip"></div>

  </div>
\`;
      pagesContainer.appendChild(slider);
      renderThumbnails();
      enableSwipe();
    };


    // Render pagination with Previous / Next
    function renderPagination() {
      const totalPages = Math.ceil(filteredData.length / pageSize);
      const pagination = document.getElementById("pagination");
      pagination.innerHTML = "";

      // PREVIOUS BUTTON
      const prevBtn = document.createElement("button");
      prevBtn.innerText = "Previous";
      prevBtn.disabled = currentPage === 0;
      prevBtn.onclick = () => {
        currentPage--;
        renderPage();
        renderPagination();
      };
      pagination.appendChild(prevBtn);

      // PAGE NUMBERS (LIMITED)
      const visiblePages = 5;
      let start = Math.max(0, currentPage - 2);
      let end = Math.min(totalPages, start + visiblePages);

      for (let i = start; i < end; i++) {
        const btn = document.createElement("button");
        btn.innerText = i + 1;
        btn.className = i === currentPage ? "active" : "";
        btn.onclick = () => {
          currentPage = i;
          renderPage();
          renderPagination();
        };
        pagination.appendChild(btn);
      }

      // NEXT BUTTON
      const nextBtn = document.createElement("button");
      nextBtn.innerText = "Next";
      nextBtn.disabled = currentPage >= totalPages - 1;
      nextBtn.onclick = () => {
        currentPage++;
        renderPage();
        renderPagination();
      };
      pagination.appendChild(nextBtn);
    }
    // Page size change
    document.getElementById("pageSizeSelect").addEventListener("change", (e) => {
      pageSize = parseInt(e.target.value);
      currentPage = 0;
      renderPage();
      renderPagination();
    });

    districtSearch.addEventListener("input", (e) => {
      renderOptions(e.target.value);
    });

    document.getElementById("searchInput").addEventListener("input", applyFilters);


    // Initial load
    filteredData = criminals;
    renderPage();
    renderPagination();
    renderOptions();


</script>

</body>
</html>
`;

      const blob = new Blob([html], { type: "text/html" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "criminal_album.html";
      link.click();
    }
  };

  openAlbum = async (criminal) => {
    try {
      const res = await adminService.generateAlbumId();

      const crimeAlbumid = res.album_unique_id;

      console.log("crimeAlbumid", crimeAlbumid);

      // Now use it safely here
      this.downloadCriminalAlbumHTML(crimeAlbumid, criminal);
    } catch (error) {
      console.error(error);
    }
  };
  getExportRows = () => {
    const { t } = this.context;

    const arrData =
      this.state.filterData?.map((data, index) => {
        const obj = {
          [t("sr.no")]: index + 1,
          Id: data.masterId,
          [t("name")]: data.name || "-",
          [t("address")]: data.address || "-",
          [t("age")]: data.age || "-",
          [t("total_crimes")]: data.totalCrimeCount || "-",
          [t("accused_police_station")]: data.districtName || "-",
          [t("photo")]: data?.image
            ? t("yes")
            : data.photo && data.photo.length > 0 && data.photo[0] != ""
              ? t("yes")
              : t("no"),
          [t("history")]:
            data?.wantedHistory?.historySheeter === "1" ? t("yes") : t("no"),
        };

        if (
          this.state.advancedFilterTitle === "लघु शीर्षक" &&
          this.state.crimeTitle?.length > 0
        ) {
          obj[t("sub_title")] = data?.subheadings || "-";
        }
        return obj;
      }) || [];
    return arrData;
  };

  download_pdf = async () => {
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title = "आरोपीची माहिती";
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: title,
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download, crimeTitle } = this.state;
    if (download == "guna_excel") {
      this.handleSearchFilterDownload();
    }
    if (download == "arophi_excel" || download === "excel") {
      this.download_csv();
    }
    if (download == "criminal_album") {
      this.openAlbum(this.state.filterData);
    }
    if (download === "pdf") {
      this.download_pdf();
    }
  };

  handleSearchFilterDownload = async () => {
    this.setState({
      excel_loader: true,
    });
    const {
      advancedFilterTitle,
      selectedHeadings,
      year,
      crimeTitle,
      selectCIty,
      advancedFilterPhoto,
      sortBy,
      sortOrder,
    } = this.state;
    const { user } = this.props;
    console.log("user", user);

    let obj = {};
    if (user?.role) {
      // Common fields
      obj = {
        heading:
          advancedFilterTitle === "शीर्षक" &&
          selectedHeadings.length > 0 &&
          selectedHeadings,
        year: year.length > 0 && year,
        basicHadering:
          advancedFilterTitle === "लघु शीर्षक" &&
          crimeTitle.length > 0 &&
          crimeTitle,
        crime_title:
          advancedFilterTitle === "मोडस" && crimeTitle.length > 0 && crimeTitle,
        cities: selectCIty.length > 0 && selectCIty,
        rulesName: advancedFilterTitle === "कायदा" && this.state.kayda,
        kalam: advancedFilterTitle === "कायदा" && this.state.kalam,
        photo: advancedFilterPhoto && advancedFilterPhoto,
        sortField: sortBy && sortBy,
        sortOrder: sortOrder && sortOrder,
        sortField: sortBy || null,
        sortOrder: sortOrder || null,
      };

      // Role-based label and ID
      if (["4", "12"].includes(user.role)) {
        obj.label = "admin";
        obj.cityId =
          this.props.user.role === "12"
            ? this.state.selected_city
            : user.cityId;
      } else if (user.role === "2") {
        obj.label = "police_side";
        obj.district = user.districtId;
      } else if (user.role === "9" || user.role === "10") {
        obj.label = "officer_side";
        obj.districtId = user.map_districtId;
      }
    }

    if (advancedFilterTitle != "") {
      if (this.state.selectedOption === "info_within_police_station_limits") {
        try {
          const response =
            await adminService.getResidentsByPoliceStationByFilterExcelDownload(
              obj,
            );
          console.log("response", response);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          let list = data.results;
          console.log("Response Data:", data);
          let totalPhotoCount = list.reduce(
            (sum, res) =>
              sum +
              (res.photo && res.photo.length > 0 && res.photo[0] !== ""
                ? 1
                : 0),
            0,
          );
          this.setState({
            filterData: list,
            filterLoading: false,
            totalAccusedCount: list.length,
            totalPhotoCount: totalPhotoCount,
            excelData: list,
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }

      if (this.state.selectedOption === "data_entered_by_police_station") {
        try {
          const response =
            await adminService.getCriminalsByPoliceStationAreaByFiterExcelDownload(
              obj,
            );
          console.log("response", response);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          let list = data.results;
          console.log("Response Data:", data);
          let totalPhotoCount = list.reduce(
            (sum, res) =>
              sum +
              (res.photo && res.photo.length > 0 && res.photo[0] !== ""
                ? 1
                : 0),
            0,
          );
          this.setState({
            excelData: list,
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      if (this.state.selectedOption == "data_entered_by_id") {
        let obj1 = {
          id: user.id,
          heading:
            advancedFilterTitle === "शीर्षक" &&
            selectedHeadings.length > 0 &&
            selectedHeadings,
          year: year.length > 0 && year,
          basicHadering:
            advancedFilterTitle === "लघु शीर्षक" &&
            crimeTitle.length > 0 &&
            crimeTitle,
          crime_title:
            advancedFilterTitle === "मोडस" &&
            crimeTitle.length > 0 &&
            crimeTitle,
          cities: selectCIty.length > 0 && selectCIty,
          rulesName: advancedFilterTitle === "कायदा" && this.state.kayda,
          kalam: advancedFilterTitle === "कायदा" && this.state.kalam,
          photo: advancedFilterPhoto && advancedFilterPhoto,
          sortField: sortBy && sortBy,
          sortOrder: sortOrder && sortOrder,
          sortField: sortBy || null,
          sortOrder: sortOrder || null,
        };
        try {
          const response =
            await adminService.getResidentsByPoliceStationByFilterExcelDownloadById(
              obj1,
            );
          console.log("response", response);
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          let list = data.results;
          console.log("Response Data:", data);
          let totalPhotoCount = list.reduce(
            (sum, res) =>
              sum +
              (res.photo && res.photo.length > 0 && res.photo[0] !== ""
                ? 1
                : 0),
            0,
          );
          this.setState({
            excelData: list,
          });
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
    }
    this.download_csv1();
    this.setState({
      excel_loader: false,
    });
  };

  getDistrictsid = () => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  download_csv = () => {
    const { t } = this.context;
    const report_name = "Accused_Details";
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;
    const ReportTitle = "आरोपीची माहिती";

    // ===================== DATA PREPARATION =====================
    const arrData =
      this.state.filterData?.map((data, index) => {
        const obj = {
          [t("sr.no")]: index + 1,
          Id: data.masterId,
          [t("name")]: data.name || "-",
          [t("mobile_number")]: data?.mobileNumber || "-",
          [t("address")]: data.address || "-",
          [t("age")]: data.age || "-",
          [t("total_crimes")]: data.totalCrimeCount || "-",
          [t("accused_police_station")]: data.districtName || "-",
          [t("photo")]: data?.image
            ? t("yes")
            : data.photo && data.photo.length > 0 && data.photo[0] != ""
              ? t("yes")
              : t("no"),
          [t("history")]:
            data?.wantedHistory?.historySheeter === "1" ? t("yes") : t("no"),
        };

        if (
          this.state.advancedFilterTitle === "लघु शीर्षक" &&
          this.state.crimeTitle?.length > 0
        ) {
          obj[t("sub_title")] = data?.subheadings || "-";
        }
        return obj;
      }) || [];

    if (!arrData.length) return;

    // ===================== STYLES =====================
    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    // ===================== WORKBOOK =====================
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];
    const headers = Object.keys(arrData[0]);
    const totalCols = headers.length;

    const cityName =
      this.props.user.role === "12"
        ? this.getCityName(this.state.selected_city)
        : this.getCityName(this.props?.user?.cityId || "");
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;

    const headerData =
      this.props?.user?.role === "2" ? `${stateName} (${cityName})` : cityName;

    // ===================== TITLES =====================
    XLSX.utils.sheet_add_aoa(ws, [[headerData]], { origin: "A1" });
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    // ===================== TABLE HEADERS (A3) =====================
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: "A3" });

    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({ r: 2, c });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    // ===================== TABLE DATA (A4) =====================
    const ws_data = arrData.map((row) => Object.values(row));
    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: "A4" });

    ws_data.forEach((row, r) => {
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + 3, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      });
    });

    // ===================== FOOTER =====================
    const footerRowIndex = ws_data.length + 6;
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center" },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    // ===================== FORMATTING =====================
    ws["!cols"] = headers.map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!rows"] = [{ hpt: 38 }, { hpt: 30 }, { hpt: 42 }];

    for (let i = 3; i < ws_data.length + 3; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }

    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };

    ws["!freeze"] = { ySplit: 3 };
    ws["!merges"] = merges;

    // ===================== EXPORT =====================
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  download_csv1 = () => {
    const { t, language } = this.context;
    const report_name = "Accused_Details";
    const file_name = `${report_name}_${moment().format("DDMMMYYYY")}`;
    const ReportTitle = "आरोपीची माहिती";

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const showSubheading = this.state.selectedFilter === "लघु शीर्षक";
    const showDateRange =
      this.state.report_type !== "history_sheeter" && this.state.from_date;

    const currentStatusLabel = `${t("current_status")} (${moment().format(
      "DD-MM-YYYY",
    )})`;

    const headers = [
      t("sr.no"),
      "Id",
      t("name"),
      t("address"),
      t("age"),
      t("mobile_number"),
      t("accused_police_station"),
      t("total_crimes"),
      t("photo"),
      t("history"),
    ];

    if (showSubheading) {
      headers.push(t("sub_title"));
    }

    headers.push(
      t("title"),
      t("crime_police_station"),
      t("crime_register_number"),
      t("crime_register_year"),
      t("crime_registration_date"),
      t("law_and_section"),
      t("preventive_action"),
      currentStatusLabel,
      t("date_from"),
      t("date_to"),
    );

    const totalCols = headers.length;
    const accusedFixedCols = showSubheading ? 11 : 10;

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([]);
    const merges = [];

    const cityName =
      this.props.user.role === "12"
        ? this.getCityName(this.state.selected_city)
        : this.getCityName(this.props?.user?.cityId || "");
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    /* ===================== TITLES ===================== */

    XLSX.utils.sheet_add_aoa(ws, [[cityName]], { origin: "A1" });
    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;
    merges.push({ s: { r: 0, c: 0 }, e: { r: 0, c: totalCols - 1 } });

    XLSX.utils.sheet_add_aoa(ws, [[ReportTitle]], { origin: "A2" });
    ws["A2"].s = subTitleStyle;
    merges.push({ s: { r: 1, c: 0 }, e: { r: 1, c: totalCols - 1 } });

    let headerExcelRow = 3;
    let dataOrigin = "A4";
    let dataStartRow0 = 3;

    if (showDateRange) {
      const dateRange = `${t("from")} ${moment(this.state.from_date).format(
        "DD-MM-YYYY",
      )}`;
      XLSX.utils.sheet_add_aoa(ws, [[dateRange]], { origin: "A3" });
      ws["A3"].s = subTitleStyle;
      merges.push({ s: { r: 2, c: 0 }, e: { r: 2, c: totalCols - 1 } });
      headerExcelRow = 4;
      dataOrigin = "A5";
      dataStartRow0 = 4;
    }

    /* ===================== HEADERS ===================== */

    XLSX.utils.sheet_add_aoa(ws, [headers], {
      origin: `A${headerExcelRow}`,
    });
    headers.forEach((_, c) => {
      const cell = XLSX.utils.encode_cell({
        r: headerExcelRow - 1,
        c,
      });
      if (ws[cell]) ws[cell].s = headerStyle;
    });

    /* ===================== DATA ===================== */

    const ws_data = [];
    const reportData = Array.isArray(this.state.excelData)
      ? this.state.excelData
      : [];

    reportData.forEach((accused, idx) => {
      const gunhas = (Array.isArray(accused.gunha_records)
        ? accused.gunha_records
        : []
      ).sort((a, b) => new Date(b.dateTime || 0) - new Date(a.dateTime || 0));
      const preventive_actions = Array.isArray(accused.preventive_records)
        ? accused.preventive_records
        : [];

      const subheadings = Array.isArray(accused.subheadings)
        ? accused.subheadings
        : [];
      const subheading = subheadings.length > 0 ? subheadings.join(", ") : "-";
      const maxRows = Math.max(gunhas.length, preventive_actions.length, 1);

      const pushAccusedCells = (row, isFirst) => {
        if (isFirst) {
          row.push(
            idx + 1,
            accused.masterId || "-",
            accused.name || "-",
            accused.address || "-",
            accused.age || "-",
            accused.mobileNumber || "-",
            accused.districtName || "-",
            accused.totalCrimeCount || "-",
            Array.isArray(accused.photo) &&
              accused.photo.length &&
              accused.photo[0] !== ""
              ? t("yes")
              : t("no"),
            accused.historySheeter == 1 ? t("yes") : t("no"),
          );
          if (showSubheading) {
            row.push(subheading);
          }
        } else {
          for (let k = 0; k < accusedFixedCols; k++) row.push("");
        }
      };

      for (let i = 0; i < maxRows; i++) {
        const row = [];
        pushAccusedCells(row, i === 0);

        const gunha = gunhas[i];
        if (gunha) {
          row.push(
            gunha.crime_title || "-",
            gunha.districtName || "-",
            gunha.registernumber || "-",
            gunha.registernumberYear
              ? moment(gunha.registernumberYear).format("YYYY")
              : "-",
            gunha.dateTime ? moment(gunha.dateTime).format("DD/MM/YYYY") : "-",
          );

          let lawData = "-";
          if (Array.isArray(gunha.kk_info) && gunha.kk_info.length > 0) {
            const grouped = {};
            gunha.kk_info.forEach((rule) => {
              const name = rule.rulesName || "-";
              const kalma = rule.kalam || "-";
              grouped[name] = grouped[name]
                ? Array.from(new Set([...grouped[name], kalma]))
                : [kalma];
            });
            lawData = Object.entries(grouped)
              .map(([name, kalmas]) => `${name}: ${kalmas.join(", ")}`)
              .join("\n");
          }
          row.push(lawData);
        } else {
          row.push("", "", "", "", "", "");
        }

        const action = preventive_actions[i];
        if (action) {
          row.push(
            action.preventive_action_name || "-",
            action.date_to && moment(action.date_to).isBefore(moment(), "day")
              ? t("completed")
              : t("ongoing"),
            action.date_from
              ? moment(action.date_from).format("DD-MM-YYYY")
              : "-",
            action.date_to
              ? moment(action.date_to).format("DD-MM-YYYY")
              : "-",
          );
        } else {
          row.push("", "", "", "");
        }

        ws_data.push(row);
      }
    });

    XLSX.utils.sheet_add_aoa(ws, ws_data, { origin: dataOrigin });

    ws_data.forEach((row, r) =>
      row.forEach((_, c) => {
        const cell = XLSX.utils.encode_cell({ r: r + dataStartRow0, c });
        if (ws[cell]) ws[cell].s = cellStyle;
      }),
    );

    const footerRowIndex = ws_data.length + (showDateRange ? 6 : 5);
    const footerContent = `Generated At ${moment().format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });

    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    merges.push({
      s: { r: footerRowIndex - 1, c: 0 },
      e: { r: footerRowIndex - 1, c: totalCols - 1 },
    });

    /* ===================== WIDTH / HEIGHT ===================== */

    const colWidths = [
      { wch: 6 },
      { wch: 12 },
      { wch: 18 },
      { wch: 28 },
      { wch: 8 },
      { wch: 14 },
      { wch: 18 },
      { wch: 12 },
      { wch: 8 },
      { wch: 10 },
    ];
    if (showSubheading) {
      colWidths.push({ wch: 18 });
    }
    colWidths.push(
      { wch: 18 },
      { wch: 18 },
      { wch: 16 },
      { wch: 14 },
      { wch: 16 },
      { wch: 36 },
      { wch: 22 },
      { wch: 18 },
      { wch: 14 },
      { wch: 14 },
    );
    ws["!cols"] = colWidths;

    ws["!rows"] = showDateRange
      ? [{ hpt: 38 }, { hpt: 30 }, { hpt: 28 }, { hpt: 42 }]
      : [{ hpt: 38 }, { hpt: 30 }, { hpt: 42 }];

    for (let i = dataStartRow0; i < ws_data.length + dataStartRow0; i++) {
      ws["!rows"][i] = { hpt: 44 };
    }
    ws["!rows"][footerRowIndex - 1] = { hpt: 28 };
    ws["!freeze"] = { ySplit: headerExcelRow };
    ws["!merges"] = merges;

    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${file_name}.xlsx`);
    this.setState({
      excel_loader: false,
    });
  };
  getPoliceStationWithGhatak = () => {
    const { user } = this.props;

    professionalAction
      .getPoliceStationWithGhatak(user.id)
      .then(async (res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await res.json();

        const cityOptions = data?.city
          ? [
              {
                id: data.city.id,
                label: `${data.city.value} (${data.city.City})`,
                value: data.city.value,
              },
            ]
          : [];

        const policeStationOptions = data?.distincts
          ? [
              {
                id: data?.distincts.id,
                label: `${data?.distincts?.value} (${data?.distincts?.DistrictName})`,
                value: data?.distincts?.value,
              },
            ]
          : [];

        this.setState({
          dataList: [...policeStationOptions, ...cityOptions],
          selectedPoliceStation: policeStationOptions[0]?.value,
        });
        this.handleSelectChange(policeStationOptions[0]?.value);
        this.setState({ districtName1: data?.distincts?.DistrictName });
      })
      .catch((error) => {})
      .finally(() => {});
  };
  handleSelectChange = (value) => {
    const selected = this.state.dataList.find((item) => item.value === value);
    this.setState({
      selectedPoliceStation: selected,
    });
  };

  searchdata = async () => {
    this.setState({
      tableLoading: true,
      totalPhotoCount: 0,
      totalAccusedCount: 0,
      is_search: true,
    });
    const { selectedPoliceStation, searchText } = this.state;
    const { user } = this.props;
    let obj = {
      value: selectedPoliceStation?.value,
      id: selectedPoliceStation?.id,
      searchText: searchText,
    };
    console.log("selectedOption", this.state.selectedOption);
    this.setState({
      filterLoading: true,
    });
    try {
      let response;
      if (this.state.selectedOption === "data_entered_by_id") {
        console.log("test");
        let obj1 = {
          value: selectedPoliceStation?.value,
          id:
            selectedPoliceStation?.value === "घटक"
              ? selectedPoliceStation?.id
              : user.id,
          searchText: searchText,
        };
        response =
          await PoliceSideActions.getResidentsByPoliceStationIdSearchByPolice(
            obj1,
          );
      }
      if (this.state.selectedOption === "info_within_police_station_limits") {
        response =
          await PoliceSideActions.getResidentsByPoliceStationSearchByPolice(
            obj,
          );
      }
      if (this.state.selectedOption === "data_entered_by_police_station") {
        response =
          await PoliceSideActions.getCriminalsByPoliceStationAreaSearchByPolice(
            obj,
          );
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("data", data);
      let totalPhotoCount = data?.data.reduce(
        (sum, res) =>
          sum +
          (res.photo && res.photo.length > 0 && res.photo[0] !== "" ? 1 : 0),
        0,
      );
      this.setState({
        filterData: data?.data,
        filterLoading: false,
        totalAccusedCount: data?.data.length,
        totalPhotoCount: totalPhotoCount,
      });
    } catch (error) {}
  };
  handleRestDistricts = () => {
    const { filter_backup } = this.state;
    let totalPhotoCount = filter_backup.reduce(
      (sum, res) => sum + (res.photo && res.photo != null ? 1 : 0),
      0,
    );
    this.setState({
      filterData: filter_backup,
      districts: [],
      districts: undefined,
      totalAccusedCount: filter_backup.length,
      totalPhotoCount: totalPhotoCount,
    });
  };

  render() {
    console.log("props render", this.props);
    console.log("city name", this.state.cityName);
    const { t } = this.context;
    const { user } = this.props;
    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from(
      { length: currentYear - 2010 + 1 },
      (_, i) => currentYear - i,
    );
    console.log("mobileDrawer", this.state.mobileDrawer);

    console.log(
      "current condition this.state.basicInformationData[0]",
      this.state.basicInformationData[0]?.current_condition,
    );
    const steps = [
      {
        title: t("accused_details"),
        content: "First-content",
        flag: 1,
      },
      {
        title: t("crime_details"),
        content: "Second-content",
        flag: 2,
      },
      {
        title: t("accused_other_information"),
        content: "Last-content",
        flag: 3,
      },
    ];

    const {
      selectedOption,
      searchType,
      searchInput,
      activeFilter,
      advancedFilterTitle,
      advancedFilterKeyword,
      advancedFilterYear,
      advancedFilterPhoto,
      showFilterOptions,
      totalAccusedCount,
      totalPhotoCount,
      selectedHeadings,
      crimeTitle,
      year,
      main_head,
      selectCIty,
      dataList,
      excel_loader,
      mapped_cities,
    } = this.state;
    const {
      criminalViewList,
      pc_cities,
      loading,
      pc_crimetypes,
      pc_crimetitles,
    } = this.props.professionals;
    console.log("this.state.selected_city", this.state.selected_city);
    return (
      <React.Fragment>
        <Spin spinning={this.state.excel_loader} size="large">
          {/* Existing page content goes here */}
          <div
            style={
              this.state.excel_loader
                ? { pointerEvents: "none", opacity: 0.5 }
                : {}
            }
          >
            <div className="site-page-header-ghost-wrapper">
              <PageHeader
                ghost={false}
                onBack={false}
                title={t("aaropi_shodha")}
                extra={[]}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 12,
                    marginBottom: "20px",
                  }}
                >
                  <Radio.Group
                    onChange={this.handleOptionChange}
                    value={selectedOption}
                  >
                    <Radio value="info_within_police_station_limits">
                      पो स्टे. हद्दीत राहणारे
                    </Radio>
                    <Radio value="data_entered_by_police_station">
                      पो स्टे. हद्दीत गुन्हे करणारे
                    </Radio>
                    {this.props?.user?.role === "2" && (
                      <Radio value="data_entered_by_id">
                        पो. स्टे नि भरलेली माहिती
                      </Radio>
                    )}
                  </Radio.Group>
                  <div className="admin-nd-header__actions">
                    <Link
                      className="admin-nd-ps-badge admin-nd-ps-badge--clickable"
                      to={
                        this.props.user.role === "2"
                          ? "/new-dashboard"
                          : "/admin-new-dashboard"
                      }
                    >
                      <UnorderedListOutlined />
                      <span type="primary">{t("analytical")}</span>
                    </Link>
                  </div>
                </div>
              </PageHeader>
              <PageHeader>
                {this.props.user.role === "12" && (
                  <Form ref={this.formRef}>
                    <Form.Item name="selected_city" label="City">
                      <Select
                        placeholder="Select city"
                        onChange={(value) => {
                          this.setState({ selected_city: value }, () => {
                            this.getData();
                            this.imageCount();
                          });
                        }}
                      >
                        {mapped_cities.map((cities) => (
                          <Option key={cities.id} value={cities.id}>
                            {cities.city}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Form>
                )}
              </PageHeader>
              <div
                style={{
                  padding: "20px",
                  background: "#fff",
                  marginBottom: "20px",
                }}
              >
                <div style={{ marginBottom: "20px" }}>
                  <Button
                    type={activeFilter === "specific" ? "primary" : "default"}
                    style={{
                      marginRight: "10px",
                      backgroundColor:
                        activeFilter === "specific" ? "#1890ff" : "",
                      borderColor: activeFilter === "specific" ? "#1890ff" : "",
                    }}
                    onClick={() => this.handleFilterChange("specific")}
                  >
                    Specific Search
                  </Button>
                  <Button
                    type={activeFilter === "advanced" ? "primary" : "default"}
                    style={{
                      backgroundColor:
                        activeFilter === "advanced" ? "#1890ff" : "",
                      borderColor: activeFilter === "advanced" ? "#1890ff" : "",
                    }}
                    onClick={() => this.handleFilterChange("advanced")}
                  >
                    Advanced Filter
                  </Button>
                </div>

                {activeFilter === "specific" && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        marginBottom: "20px",
                      }}
                    >
                      <Select
                        placeholder={t("search_type_select")}
                        style={{ width: 200 }}
                        onChange={this.handleSearchTypeChange}
                        value={searchType}
                      >
                        <Option value="name">{t("name")}</Option>
                        <Option value="crime">गुन्हा</Option>
                        <Option value="masterId">CMIS ID</Option>
                        <Option value="mobile_no">{t("mobile_number")}</Option>
                        <Option value="adhaar_number">
                          {t("aadhaar_number")}
                        </Option>
                      </Select>
                      {(["9", "10", "12"].includes(user.role) ||
                        searchType === "crime") && (
                        <Input
                          placeholder={t("name_crime_id_enter")}
                          style={{ flex: 1 }}
                          value={searchInput}
                          onChange={this.handleSearchInputChange}
                        />
                      )}
                      {["4"].includes(user.role) &&
                        (searchType === "name" ||
                          searchType === "masterId") && (
                          <>
                            <Input
                              placeholder={t("name_crime_id_enter")}
                              style={{ flex: 1 }}
                              value={searchInput}
                              onChange={this.handleSearchInputChange}
                            />
                            <Form.Item
                              style={{ marginBottom: 0, flexGrow: 1 }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a police station",
                                },
                              ]}
                            >
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Select value"
                                onChange={this.handleNameType}
                                value={this.state.selectedNameType}
                              >
                                <Select.Option value="self">
                                  {this.state.cityName}
                                </Select.Option>
                                <Select.Option value="all">
                                  संपूर्ण घटक
                                </Select.Option>
                              </Select>
                            </Form.Item>
                          </>
                        )}
                      {["4", "2"].includes(user.role) &&
                        (searchType === "mobile_no" ||
                          searchType === "adhaar_number") && (
                          <>
                            <Input
                              placeholder={t("search")}
                              style={{ flex: 1 }}
                              value={searchInput}
                              onChange={this.handleSearchInputChange}
                            />
                          </>
                        )}

                      {searchType === "name" &&
                        this.props.user.role === "2" && (
                          <>
                            <Form.Item
                              style={{ marginBottom: 0, flexGrow: 1 }}
                              rules={[
                                {
                                  required: true,
                                  message: "Please select a police station",
                                },
                              ]}
                            >
                              <Select
                                style={{ width: "100%" }}
                                placeholder="Select value"
                                onChange={this.handleSelectChange}
                                value={this.state.selectedPoliceStation}
                                defaultValue={this.state.selectedPoliceStation}
                              >
                                {dataList &&
                                  Array.isArray(dataList) &&
                                  dataList.map((item) => (
                                    <Select.Option
                                      key={item.id}
                                      value={item.value}
                                    >
                                      {item.label}
                                    </Select.Option>
                                  ))}
                              </Select>
                            </Form.Item>
                            {this.state.selectedPoliceStation && (
                              <Input
                                placeholder={t("search")}
                                value={this.state.searchText}
                                onChange={(e) =>
                                  this.setState({
                                    searchText: e.target.value,
                                  })
                                }
                                allowClear
                                style={{ flexGrow: 1 }}
                              />
                            )}
                          </>
                        )}
                      {searchType === "crime" && (
                        <Select
                          mode="multiple"
                          allowClear
                          placeholder={t("crimes_year")}
                          value={year}
                          onChange={(val) => this.handleYear(val.map(Number))}
                          style={{ minWidth: 140, flex: 1 }}
                          showSearch
                          maxTagCount={1}
                        >
                          {yearOptions.map((y) => (
                            <Option key={y} value={y}>
                              {y}
                            </Option>
                          ))}
                        </Select>
                      )}
                      {user.role === "2" && searchType === "masterId" && (
                        <Input
                          placeholder={t("name_crime_id_enter")}
                          style={{ flex: 1 }}
                          value={searchInput}
                          onChange={this.handleSearchInputChange}
                        />
                      )}
                    </div>
                    <div>
                      {["name", "masterId", "crime"].includes(searchType) &&
                        ["9", "10", "12"].includes(user.role) && (
                          <Button
                            disabled={
                              !this.state.searchInput && !this.state.searchType
                            }
                            type="primary"
                            icon={<SearchOutlined />}
                            style={{ marginRight: "10px" }}
                            onClick={() => {
                              this.handleSearch();
                            }}
                          >
                            {t("find")}
                          </Button>
                        )}
                      {searchType === "crime" && ["4"].includes(user.role) && (
                        <Button
                          disabled={
                            !this.state.searchInput && !this.state.searchType
                          }
                          type="primary"
                          icon={<SearchOutlined />}
                          style={{ marginRight: "10px" }}
                          onClick={() => {
                            this.handleSearch();
                          }}
                        >
                          {t("find")}
                        </Button>
                      )}
                      {["4"].includes(user.role) &&
                        (searchType === "name" ||
                          searchType === "masterId" ||
                          searchType === "mobile_no" ||
                          searchType === "mobile_no" ||
                          searchType === "adhaar_number") && (
                          <Button
                            disabled={
                              !this.state.selectedNameType &&
                              !this.state.searchType
                            }
                            type="primary"
                            icon={<SearchOutlined />}
                            style={{ marginRight: "10px" }}
                            onClick={() => {
                              this.handleNameTypeSearch();
                            }}
                          >
                            {t("find")}
                          </Button>
                        )}
                      {this.props?.user.role === "2" &&
                        searchType === "name" && (
                          <>
                            <Button
                              disabled={!this.state.searchText}
                              type="primary"
                              style={{ marginRight: "10px" }}
                              onClick={() => this.searchdata()}
                            >
                              {t("find")}
                            </Button>
                          </>
                        )}
                      {this.props.user.role === "2" && searchType != "name" && (
                        <Button
                          disabled={
                            !this.state.searchInput && !this.state.searchType
                          }
                          type="primary"
                          icon={<SearchOutlined />}
                          style={{ marginRight: "10px" }}
                          onClick={() => {
                            this.handleSearch();
                          }}
                        >
                          {t("find")}
                        </Button>
                      )}

                      {(this.state.searchInput ||
                        this.state.searchType ||
                        (this.state.crimeList &&
                          this.state.crimeList.length > 0)) && (
                        <Button
                          icon={<RedoOutlined />}
                          onClick={this.handleReset}
                        >
                          Reset
                        </Button>
                      )}
                    </div>
                  </>
                )}

                {activeFilter === "advanced" && (
                  <>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <label style={{ marginBottom: "5px" }}>
                          शीर्षक / लघुशीर्षक / कायदा-कलम निवडा
                        </label>
                        <Select
                          placeholder="Select Title"
                          onChange={this.handleAdvancedFilterTitleChange}
                          value={advancedFilterTitle}
                        >
                          <Option value="शीर्षक">{t("title")}</Option>
                          <Option value="लघु शीर्षक">{t("sub_title")}</Option>
                          <Option value="मोडस">{t("modus_operandi")}</Option>
                          <Option value="कायदा">
                            {" "}
                            {`${t("law")} / ${t("section")}`}
                          </Option>
                        </Select>
                      </div>
                      {advancedFilterTitle != null && (
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label style={{ marginBottom: "5px" }}>
                            {advancedFilterTitle === "शीर्षक"
                              ? t("title")
                              : advancedFilterTitle === "लघु शीर्षक"
                              ? t("sub_title")
                              : advancedFilterTitle === "मोडस"
                              ? t("modus_operandi")
                              : `${t("law")} / ${t("section")}`}
                          </label>
                          {advancedFilterTitle === "शीर्षक" && (
                            <>
                              <Select
                                mode="multiple"
                                placeholder="Please select Crime Type"
                                value={selectedHeadings}
                                onChange={(val) =>
                                  this.setState({ selectedHeadings: val })
                                }
                                style={{ minWidth: 220, flex: 1 }}
                                showSearch
                                maxTagCount={1}
                              >
                                {pc_crimetitles?.map((res) => (
                                  <Option key={res.id} value={res.id}>
                                    {res.crime_title}
                                  </Option>
                                ))}
                              </Select>
                            </>
                          )}
                          {advancedFilterTitle === "लघु शीर्षक" && (
                            <>
                              <Select
                                mode="multiple"
                                placeholder="Please select Crime Type"
                                value={crimeTitle}
                                onChange={(val) =>
                                  this.setState({ crimeTitle: val })
                                }
                                style={{ minWidth: 220, flex: 1 }}
                                showSearch
                                maxTagCount={1}
                              >
                                {pc_crimetypes?.map((res) => (
                                  <Option key={res.id} value={res.id}>
                                    {res.crimetype}
                                  </Option>
                                ))}
                              </Select>
                            </>
                          )}
                          {advancedFilterTitle === "मोडस" && (
                            <Select
                              filterOption={(input, option) =>
                                option?.children
                                  .toLowerCase()
                                  .includes(input.toLowerCase())
                              }
                              mode="multiple"
                              optionFilterProp="children"
                              allowClear
                              placeholder="Please select option"
                              value={this.state.crimeTitle}
                              onChange={(val) =>
                                this.setState({ crimeTitle: val })
                              }
                              style={{ minWidth: 220, flex: 1 }}
                              showSearch
                              maxTagCount={1}
                            >
                              {main_head?.map((item) => (
                                <Option
                                  key={item.title_id}
                                  value={item.title_id}
                                >
                                  {item.main_head_type}
                                </Option>
                              ))}
                            </Select>
                          )}
                          {advancedFilterTitle === "कायदा" && (
                            <Row gutter={[16, 16]}>
                              <Col span={24}>
                                <Select
                                  allowClear
                                  placeholder={t("please_select_an_option")}
                                  value={this.state.kayda}
                                  onChange={(val) => this.handleKala(val)}
                                  style={{ minWidth: 220, flex: 1 }}
                                  showSearch
                                  maxTagCount={1}
                                  filterOption={(input, option) =>
                                    option?.children
                                      .toLowerCase()
                                      .includes(input.toLowerCase())
                                  }
                                >
                                  {this.props.professionals?.pc_acts?.map(
                                    (item) => (
                                      <Option
                                        key={item.act_cd}
                                        value={item.act_cd}
                                      >
                                        {item.kayda}
                                      </Option>
                                    ),
                                  )}
                                </Select>
                              </Col>
                              {this.state.kayda && (
                                <Col span={24}>
                                  <Select
                                    filterOption={(input, option) =>
                                      option?.children
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                    }
                                    optionFilterProp="children"
                                    mode="multiple"
                                    allowClear
                                    placeholder="Please select option"
                                    value={this.state.kalam}
                                    onChange={(val) =>
                                      this.setState({ kalam: val })
                                    }
                                    style={{ minWidth: 220, flex: 1 }}
                                    showSearch
                                    maxTagCount={1}
                                  >
                                    {this.props.professionals?.pc_kalams?.map(
                                      (item) => (
                                        <Option
                                          key={item.section}
                                          value={item.section}
                                        >
                                          {item.section}
                                        </Option>
                                      ),
                                    )}
                                  </Select>
                                </Col>
                              )}
                            </Row>
                          )}
                        </div>
                      )}
                      {/* sir told comment this we adding into another section */}
                      {/* <div style={{ display: 'flex', flexDirection: 'column' }}>
                                        <label style={{ marginBottom: '5px' }}>घटक</label>
                                        <Select
                                            placeholder="Select Component"
                                            onChange={this.handleAdvancedFilterComponentChange}
                                            value={selectCIty}
                                            mode="multiple"
                                        >
                                            {pc_cities.map((cities) => (
                                                <Option key={cities.id} value={cities.id}>
                                                    {cities.City}
                                                </Option>
                                            ))}

                                        </Select>
                                    </div> */}
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <label style={{ marginBottom: "5px" }}>
                          गुन्ह्याचे वर्ष
                        </label>
                        <Select
                          mode="multiple"
                          allowClear
                          placeholder={t("crimes_year")}
                          value={year}
                          onChange={(val) => this.handleYear(val.map(Number))}
                          style={{ minWidth: 140, flex: 1 }}
                          showSearch
                          maxTagCount={1}
                        >
                          {yearOptions.map((y) => (
                            <Option key={y} value={y}>
                              {y}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <div>
                        <Button
                          type="primary"
                          icon={<SearchOutlined />}
                          style={{
                            marginRight: "10px",
                            backgroundColor: "#1890ff",
                            borderColor: "#1890ff",
                          }}
                          onClick={this.handleSearchFilter}
                        >
                          Search
                        </Button>
                        <Button
                          icon={<RedoOutlined />}
                          onClick={this.handleReset}
                        >
                          Reset
                        </Button>
                      </div>
                      <Form.Item style={{ marginBottom: 0 }}>
                        <Select
                          defaultValue={this.state.download}
                          placeholder={t("please_select_an_option")}
                          value={this.state.download || "excel"}
                          onChange={(value) =>
                            this.setState({ download: value })
                          }
                          style={{ minWidth: "160px" }}
                        >
                          <Option key="arophi_excel">
                            {t("accused_excel")}
                          </Option>
                          {this.props?.user?.role === "2" && (
                            <Option key="guna_excel">
                              {t("crime_statistics")}
                            </Option>
                          )}
                          {["4", "9", "10", "2"].includes(user.role) && (
                            <Option key="criminal_album">डिजिटल अल्बम</Option>
                          )}
                          <Option value="pdf">PDF</Option>
                        </Select>
                      </Form.Item>

                      <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        style={{
                          background: "#52c41a",
                          borderColor: "#52c41a",
                        }}
                        disabled={!this.state.filterData?.length}
                        onClick={this.downloadReport}
                      >
                        Download
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "20px",
                marginTop: "20px",
                marginBottom: "20px",
              }}
            >
              <div
                style={{
                  background: "#6f42c1",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {t("total_accused_count")}: {totalAccusedCount}
                </span>
              </div>
              <div
                style={{
                  background: "#28a745",
                  color: "#fff",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                  {t("total_photo_count")}: {totalPhotoCount}
                </span>
              </div>
              {this.state.activeFilter === "advanced" &&
                this.state.filter_backup.length > 0 &&
                this.props.user.role != 2 && (
                  <>
                    <Select
                      mode="multiple"
                      style={{ minWidth: "180px" }}
                      placeholder="Select Police station"
                      value={this.state.districts || []}
                      onChange={(val) => this.handleDistricts(val)}
                      showSearch
                      allowClear
                      optionFilterProp="children"
                      maxTagCount={2} // 👈 important
                      className="custom-clear-select"
                    >
                      {this.props.professionals.basicDistricts.map((d) => (
                        <Option key={d.DistrictName} value={d.DistrictName}>
                          {d.DistrictName}
                        </Option>
                      ))}
                    </Select>
                    {this.state?.districts && (
                      <Button
                        icon={<RedoOutlined />}
                        onClick={this.handleRestDistricts}
                      >
                        Reset
                      </Button>
                    )}
                  </>
                )}
            </div>
            {this.state.activeFilter != "advanced" && (
              <>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    marginBottom: "20px",
                  }}
                >
                  <span style={{ whiteSpace: "nowrap" }}>Sort by:</span>
                  <Select
                    value={this.state.sortBy}
                    style={{ width: 120 }}
                    onChange={this.handleSortByChange}
                  >
                    <Select.Option value="srNo">-- Select --</Select.Option>
                    <Select.Option value="name">Name</Select.Option>
                    <Select.Option value="age">Age</Select.Option>
                    <Select.Option value="address">Address</Select.Option>
                    <Select.Option value="districtName">पो. ठाणे</Select.Option>
                    <Select.Option value="totalcrimeCount">
                      {t("sort_by_total_crimes")}
                    </Select.Option>
                  </Select>
                  <Select
                    value={this.state.sortOrder}
                    style={{ width: 120 }}
                    onChange={this.handleSortOrderChange}
                  >
                    <Select.Option value="asc">Ascending</Select.Option>
                    <Select.Option value="desc">Descending</Select.Option>
                  </Select>
                  <Button
                    icon={<RedoOutlined />}
                    onClick={this.handleResetFilter}
                  >
                    Reset
                  </Button>
                </div>
              </>
            )}

            {this.state.activeFilter === "advanced" &&
              this.state.filterData.length > 0 && (
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      marginBottom: "20px",
                    }}
                  >
                    <span style={{ whiteSpace: "nowrap" }}>Sort by:</span>
                    <Select
                      value={this.state.sortBy}
                      style={{ width: 120 }}
                      onChange={this.handleSortByChange}
                    >
                      <Select.Option value="srNo">-- Select --</Select.Option>
                      <Select.Option value="name">Name</Select.Option>
                      <Select.Option value="age">Age</Select.Option>
                      <Select.Option value="address">Address</Select.Option>
                      <Select.Option value="districtName">
                        पो. ठाणे
                      </Select.Option>
                      <Select.Option value="totalCrimeCount">
                        {t("sort_by_total_crimes")}
                      </Select.Option>
                    </Select>
                    <Select
                      value={this.state.sortOrder}
                      style={{ width: 120 }}
                      onChange={this.handleSortOrderChange}
                    >
                      <Select.Option value="asc">Ascending</Select.Option>
                      <Select.Option value="desc">Descending</Select.Option>
                    </Select>
                    <Button
                      icon={<RedoOutlined />}
                      onClick={this.handleResetFilter}
                    >
                      Reset
                    </Button>
                    <label>फोटो:</label>
                    <Radio.Group
                      onChange={this.handleAdvancedFilterPhotoChange}
                      value={advancedFilterPhoto}
                      disabled={
                        !this.state.filterData ||
                        this.state.filterData.length === 0
                      }
                    >
                      <Radio value="all">सर्व</Radio>
                      <Radio value="yes">होय</Radio>
                      <Radio value="no">नाही</Radio>
                    </Radio.Group>
                  </div>
                </>
              )}
            {(activeFilter === "advanced" && this.state.is_filter == true) ||
            (activeFilter === "specific" && this.state.is_search == true) ? (
              <FilterList
                loading={this.state.filterLoading}
                data={this.state.filterData}
                professionals={this.props.professionals}
                onViewAccusedDetails={this.onViewAccusedForm}
                advancedFilterTitle={advancedFilterTitle}
                filter={this.state.is_filter}
                is_search={this.state.is_search}
                role={this.props.user.role}
                onEditAccusedForm={this.onEditAccusedForm}
                onPreventiveViewAccusedForm={this.onPreventiveViewAccusedForm}
                onNCRViewAccusedForm={this.onNCRViewAccusedForm}
                user={user}
                handleMultipleMobile={this.handleMultipleMobile}
                openDocumentVerified={this.openDocumentVerified}
                district={this.props.basicDistricts}
                activeFilter={activeFilter}
              />
            ) : (
              <TableCrimeList
                preventive_action={this.props.preventive_action}
                getSerialNumber={this.getSerialNumber}
                onEditAccusedForm={this.onEditAccusedForm}
                data={this.state.criminalList}
                onViewAccusedDetails={this.onViewAccusedForm}
                onCriminalActiveStatus={this.onCriminalActiveStatus}
                onPreventiveViewAccusedForm={this.onPreventiveViewAccusedForm}
                usersData={user}
                current={this.state.currentPage}
                pageSize={this.state.pageSize}
                total={this.state.totalAccusedCount}
                handlePageChange={this.handlePageChange}
                handlePageSizeChange={this.handlePageSizeChange}
                loading={this.state.tableLoading}
                selectedOption={this.state.selectedOption}
                is_search={this.state.is_search}
                onNCRViewAccusedForm={this.onNCRViewAccusedForm}
                handleMultipleMobile={this.handleMultipleMobile}
                openDocumentVerified={this.openDocumentVerified}
              ></TableCrimeList>
            )}
          </div>
        </Spin>

        <Drawer
          title="आरोपीची माहिती"
          width={900}
          maskClosable={false}
          closable={false}
          onClose={this.onCloseAccusedDrawer}
          visible={this.state.accusedDrawer}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.onCloseAccusedDrawer}
                    style={{ marginRight: 8 }}
                  >
                    {t("cancel")}
                  </Button>
                </div>

                <div>
                  {this.state.current > 0 && (
                    <Button
                      onClick={() => this.prev()}
                      style={{ marginRight: 8 }}
                    >
                      {t("previous")}
                    </Button>
                  )}
                  {this.state.current < steps.length - 1 && (
                    <Button type="primary" onClick={() => this.next()}>
                      {t("next")}
                    </Button>
                  )}
                  {this.state.current === steps.length - 1 &&
                    // onClick={() => this.done()}

                    this.state.isEditForms && (
                      <Button onClick={this.onUpdateConfirm} type="primary">
                        {t("update")}
                      </Button>
                    )}
                </div>
              </div>
            </div>
          }
        >
          <Steps current={this.state.current}>
            {steps.map((item) => (
              <Step key={item.title} title={item.title} />
            ))}
          </Steps>
          <div className="steps-content mb-4" style={{ marginTop: "30px" }}>
            <Divider />
            {steps[this.state.current].flag === 1 ? (
              this.state.newflag === 0 ? (
                <PageHeader
                  className="site-page-header"
                  ghost={false}
                  onBack={false}
                  title={"आरोपी शोधा"}
                >
                  <Spin spinning={this.state.tableLoading}></Spin>
                  <Divider />
                </PageHeader>
              ) : (
                <BasicInformation
                  ref={this.basicInformationRef}
                  basicInformationFinish={this.basicInformationFinish}
                  basicInformationData={this.state.basicInformationData}
                  wantedHistory={this.state.wantedHistory}
                  dataStates={this.props.professionals}
                  onCityChange={this.onCityChange}
                  isEditForms={this.state.isEditForms}
                  uploadImage={this.uploadImage}
                  resetBasicForm={this.state.resetBasicForm}
                  is_document_verified={this.state.is_document_verified}
                ></BasicInformation>
              )
            ) : steps[this.state.current].flag === 2 ? (
              <div>
                <Button
                  type="primary"
                  size="large"
                  className="pro-gov-btn animated-btn"
                  onClick={this.showghunhaDrawer}
                >
                  आणखी गुन्हा जोडा
                </Button>
                {this.state.ghunhaInfomationData.length ? (
                  <GhunhaInfomationTable
                    data={this.state.ghunhaInfomationData}
                    editGhunhaInfomation={this.editGhunhaInfomation}
                    deleteGhunhaInfomation={this.deleteGhunhaInfomation}
                    editArrestInfomation={this.editArrestInfomation}
                    editNoticeInformation={this.editNoticeInformation}
                    professionals={this.props.professionals}
                    isEditForms={this.state.isEditForms}
                  ></GhunhaInfomationTable>
                ) : null}
                <Drawer
                  title="गुन्हा"
                  width={800}
                  maskClosable={false}
                  closable={false}
                  onClose={this.onghunhaDrawerClose}
                  visible={this.state.ghunhaDrawer}
                  footer={
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <Button
                        onClick={this.onGhunhaInfomationCancel}
                        style={{ marginRight: 8 }}
                      >
                        {t("cancel")}
                      </Button>
                      {!this.state.isGunhaEdit ? (
                        <Button
                          onClick={this.onGhunhaInfomationSave}
                          type="primary"
                        >
                          {t("save")}
                        </Button>
                      ) : (
                        <Button
                          onClick={this.onGhunhaInfomationUpdate}
                          type="primary"
                        >
                          {t("update")}
                        </Button>
                      )}
                    </div>
                  }
                >
                  <GhunhaInfomation
                    ref={this.ghunhaInfomationRef}
                    newGunha={this.state.newGunha}
                    onGunhaFormFiniesh={this.onGunhaFormFiniesh}
                    onGunhaFormUpdate={this.onGunhaFormUpdate}
                    openKalamAndKaydaDrawer={this.openKalamAndKaydaDrawer}
                    dataStates={this.props.professionals}
                    editData={this.state.editGunhaInformationData}
                    onCityChange={this.onCityChange}
                    onKaydaChange={this.onKaydaChange}
                    masterId={this.state.masterId}
                    role={this.props.user.role}
                    city={this.props.user.cityId}
                    id={this.props.user.id}
                    districtId={
                      this.state.selectdistrict
                        ? this.props.user.districtId
                        : ""
                    }
                  ></GhunhaInfomation>
                </Drawer>
                <Drawer
                  title="अटक फॉर्म"
                  width={800}
                  maskClosable={false}
                  closable={false}
                  onClose={this.onarrestDrawerClose}
                  visible={this.state.arrestDrawer}
                  footer={
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <Button
                        onClick={this.onArrestInfomationCancel}
                        style={{ marginRight: 8 }}
                      >
                        {t("cancel")}
                      </Button>
                      {!this.state.isArrestEdit ? (
                        <Button
                          onClick={this.onArrestInfomationSave}
                          type="primary"
                          disabled={this.state.arrestCreateLoad}
                          loading={this.state.arrestCreateLoad}
                        >
                          {t("save")}
                        </Button>
                      ) : (
                        <Button
                          onClick={this.onArrestInfomationUpdate}
                          type="primary"
                          disabled={this.state.arrestUpdateLoading}
                          loading={this.state.arrestUpdateLoading}
                        >
                          {t("update")}
                        </Button>
                      )}
                    </div>
                  }
                >
                  <ArrestForm
                    ref={this.arrestInfomationRef}
                    newGunha={this.state.newGunha}
                    onArrestFormFiniesh={this.onArrestFormFiniesh}
                    onArrestFormUpdate={this.onArrestFormUpdate}
                    dataStates={this.props.professionals}
                    editData={this.state.arrestInformationData}
                    onCityChange={this.onCityChange}
                    sadyasthitiData={this.state.sadyasthitiData}
                    role={this.props?.user.role}
                    district={
                      this.props?.user?.role === "2" &&
                      this.props?.user?.districtId
                    }
                  ></ArrestForm>
                </Drawer>
                <Drawer
                  title="नोटीस"
                  width={800}
                  maskClosable={false}
                  closable={false}
                  onClose={this.onNoticeDrawerClose}
                  visible={this.state.noticeDrawer}
                  footer={
                    <div
                      style={{
                        textAlign: "right",
                      }}
                    >
                      <Button
                        onClick={this.onNoticeDrawerClose}
                        style={{ marginRight: 8 }}
                      >
                        {t("cancel")}
                      </Button>
                      {!this.state.isNoticeEdit ? (
                        <Button
                          onClick={this.onNoticeInfromationSave}
                          type="primary"
                        >
                          {t("save")}
                        </Button>
                      ) : (
                        <Button
                          onClick={this.onNoticeInfromationUpdate}
                          type="primary"
                        >
                          {t("update")}
                        </Button>
                      )}
                    </div>
                  }
                >
                  <NoticeForm
                    ref={this.noticeInformationRef}
                    newGunha={this.state.newGunha}
                    onNoticeFormFiniesh={this.onNoticeFormFiniesh}
                    onNoticeInfromationFormUpdate={this.onNoticeFormUpdate}
                    dataStates={this.props.professionals}
                    editData={this.state.noticeInformationData}
                    onCityChange={this.onCityChange}
                    role={this.props.user.role}
                    district={user?.districtId}
                  />
                </Drawer>
              </div>
            ) : steps[this.state.current].flag === 3 ? (
              <div>
                <OtherInformation
                  ref={this.otherInfomationRef}
                  uploadImage={this.uploadImage}
                  otherInformationData={this.state.otherInformationData}
                  otherInformationFiniesh={this.otherInformationFiniesh}
                  isEditForms={this.state.isEditForms}
                ></OtherInformation>
              </div>
            ) : (
              ""
            )}
          </div>
        </Drawer>
        <Drawer
          title="आरोपीचे ओळखपत्र जोडा"
          width={900}
          maskClosable={false}
          closable={false}
          onClose={this.closeDocumentVerified}
          visible={this.state.document_verified}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.closeDocumentVerified}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          }
        >
          <CrimeDocumentVerification
            masterId={this.state.masterDataId}
            closeDocumentVerified={this.closeDocumentVerified}
            user={this.props.user}
          />
        </Drawer>
        <Modal
          title="Reason"
          visible={this.state.criminalActiveModel}
          onOk={this.onCriminalActiveStatusChange}
          onCancel={this.onCriminalActiveStatusCancel}
        >
          <TextArea
            rows={4}
            value={this.state.criminalActiveReasoneValue}
            onChange={this.onCriminalActiveInputChange}
            style={{ width: "100%" }}
          />
        </Modal>
        <Drawer
          title="प्रोफेशनल क्रिमिनल Preventive (प्रतिबंधक कारवाही)"
          width={800}
          maskClosable={false}
          closable={false}
          onClose={this.onClosePreventiveAccusedDrawer}
          visible={this.state.accusedPreventiveDrawer}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.onClosePreventiveAccusedDrawer}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                </div>
                {/* <div>
                <Button
                  onClick={this.onPreventiveInfomationSave}
                  type="primary" >
                   Save
                </Button>
                </div> */}
              </div>
            </div>
          }
        >
          <div className="steps-content mb-4" style={{ marginTop: "2px" }}>
            <Button
              type="primary"
              style={{ marginBottom: "5px" }}
              onClick={this.showpreventiveDrawer}
            >
              प्रतिबंधक कारवाही जोडा
            </Button>
            {this.state.preventiveInformationData.length ? (
              <PreventiveInfomationTable
                data={this.state.preventiveInformationData}
                editPreventiveInfomation={this.editPreventiveInfomation}
                //deleteGhunhaInfomation={this.deleteGhunhaInfomation}
                professionals={this.props.professionals}
                isEditForms={this.state.isEditForms}
                preventiveAction={this.state.preventiveAction}
                role={this.props.user.role}
                user={this.props.user}
              ></PreventiveInfomationTable>
            ) : null}

            <Drawer
              title="प्रतिबंधक कारवाही"
              width={800}
              maskClosable={false}
              closable={false}
              onClose={this.onpreventiveDrawerClose}
              visible={this.state.preventiveDrawer}
              footer={
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <Button
                    onClick={this.onpreventiveDrawerClose}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                  {!this.state.isPreventiveEdit ? (
                    <Button
                      onClick={this.onPreventiveInfomationSave}
                      type="primary"
                      htmlType="submit"
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      onClick={this.onPreventiveInfomationUpdate}
                      type="primary"
                      htmlType="submit"
                    >
                      Update
                    </Button>
                  )}
                </div>
              }
            >
              <PreventiveForm
                ref={this.preventiveInfoRef}
                preventiveInformationFinish={this.preventiveInformationFinish}
                preventiveInformationUpdate={this.preventiveInformationUpdate}
                preventiveInformationData={this.state.preventiveInformationData}
                editPreventiveInformationData={
                  this.state.editPreventiveInformationData
                }
                dataStates={this.props.professionals}
                isEditForms={this.state.isEditForms}
                resetPreventiveForm={this.state.resetPreventiveForm}
                preventiveAction={this.state.preventiveAction}
                role={user?.role}
                district={user?.districtId}
                user={this.props.user}
              ></PreventiveForm>
            </Drawer>
          </div>
        </Drawer>
        <Drawer
          title="Mutiple Mobile and address"
          width={800}
          maskClosable={false}
          closable={false}
          onClose={this.onCloseMultipleMobileNumber}
          visible={this.state.is_multiple_mobile}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.onCloseMultipleMobileNumber}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          }
        >
          <Tabs defaultActiveKey="1">
            <TabPane tab="Mobile" key="1">
              <Button
                type="primary"
                size="large"
                className="pro-gov-btn animated-btn"
                onClick={this.showMobileDrawer}
              >
                आणखी जोडा
              </Button>
              {this.state.mobile.length ? (
                <MultipleMobileAddress
                  data={this.state.mobile}
                  mobile={"Mobile"}
                  city={this.props.user.cityId}
                  district={this.props.user.districtId}
                  userid={this.props.user.id}
                  getMobileData={this.getMobileData}
                />
              ) : null}
            </TabPane>

            <TabPane tab="Address" key="2">
              <Button
                type="primary"
                size="large"
                className="pro-gov-btn animated-btn"
                onClick={this.showAddressDrawer}
              >
                आणखी जोडा
              </Button>
              {this.state.mobile.length ? (
                <MultipleMobileAddress
                  data={this.state.mobile}
                  address="address"
                  city={this.props.user.cityId}
                  district={this.props.user.districtId}
                  userid={this.props.user.id}
                  getMobileData={this.getMobileData}
                />
              ) : null}
            </TabPane>
          </Tabs>

          <Drawer
            title=""
            width={800}
            maskClosable={false}
            closable={false}
            onClose={this.onMobileaDrawerClose}
            visible={this.state.mobileDrawer}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Button
                  onClick={this.onMobileaDrawerClose}
                  style={{ marginRight: 8 }}
                >
                  {t("cancel")}
                </Button>
                <Button onClick={this.OnMobileInfromationSave} type="primary">
                  {t("save")}
                </Button>
              </div>
            }
          >
            <MultipleMobile
              ref={this.mobileRef}
              onMobileFormFiniesh={this.OnMobileFormFinsiesh}
              city={this.props.user.cityId}
              district={this.props.user.districtId}
              userid={this.props.user.id}
              masterId={this.state.masterDataId}
              type="mobile"
            />
          </Drawer>
          <Drawer
            title=""
            width={800}
            maskClosable={false}
            closable={false}
            onClose={this.closeAddressDrawer}
            visible={this.state.addresDrawer}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              >
                <Button
                  onClick={this.closeAddressDrawer}
                  style={{ marginRight: 8 }}
                >
                  {t("cancel")}
                </Button>
                <Button onClick={this.OnMobileInfromationSave} type="primary">
                  {t("save")}
                </Button>
              </div>
            }
          >
            <MultipleMobile
              ref={this.addressRef}
              onMobileFormFiniesh={this.OnMobileFormFinsiesh}
              city={this.props.user.cityId}
              district={this.props.user.districtId}
              userid={this.props.user.id}
              masterId={this.state.masterDataId}
              type="address"
            />
          </Drawer>
        </Drawer>
        <Drawer
          title={t("crNumber")}
          width={800}
          maskClosable={false}
          closable={false}
          onClose={this.onCloseNCRnumber}
          visible={this.state.ncrShow}
          footer={
            <div
              style={{
                textAlign: "right",
              }}
            >
              <div
                className="steps-action"
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <div>
                  <Button
                    onClick={this.onCloseNCRnumber}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          }
        >
          <div className="steps-content mb-4" style={{ marginTop: "2px" }}>
            <Button
              type="primary"
              style={{ marginBottom: "5px" }}
              onClick={this.showNcrDrawer}
            >
              अदखलपात्र गुन्हा जोडा
            </Button>
            {this.state.ncrInformationData.length ? (
              <NCRInfomationTable
                data={this.state.ncrInformationData}
                professionals={this.props.professionals}
                isEditForms={this.state.isEditForms}
                role={this.props.user.role}
                user={this.props.user}
              ></NCRInfomationTable>
            ) : null}
            <Drawer
              title="अदखलपात्र गुन्हा"
              width={800}
              maskClosable={false}
              closable={false}
              onClose={this.onNcrDrawerClose}
              visible={this.state.ncrDrawer}
              footer={
                <div
                  style={{
                    textAlign: "right",
                  }}
                >
                  <Button
                    onClick={this.onNcrDrawerClose}
                    style={{ marginRight: 8 }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={this.onNCRInfomationSave}
                    type="primary"
                    htmlType="submit"
                  >
                    Save
                  </Button>
                </div>
              }
            >
              <NCRForm
                ncrInformationFinish={this.ncrInformationFinish}
                ref={this.ncrInformation}
                role={user?.role}
                district={user?.districtId}
                onKaydaChange={this.onKaydaChange}
                dataStates={this.props.professionals}
                isEditForms={this.state.isEditForms}
              />
            </Drawer>
          </div>
        </Drawer>

        <Modal
          title="आरोपी प्रोफाइल"
          top
          visible={this.state.setCriminalViewModel}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
        >
          <ViewFormModel
            key={this.props && this.props.user.id}
            dataStates={this.props.professionals}
            preventiveAction={this.state.preventiveAction}
          ></ViewFormModel>
        </Modal>
      </React.Fragment>
    );
  }
}
function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedAaropiShodha = connect(mapStateToProps)(AaropiShodha);
export { connectedAaropiShodha as AaropiShodha };
